// Generated by Avo VERSION 235.16.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "nEoyD5TzJ8IPCnth9ovx";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "NrliJGrxNjiWh800Xtjy",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "ghBUMPbYP",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "NrliJGrxNjiWh800Xtjy",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "ghBUMPbYP",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "JmwsgKTQe50MTmUE9FVs",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export const ConfiguratorType = {
  'COAT': 'coat',
  'JACKET': 'jacket',
  'SHIRT': 'shirt',
  'SUIT': 'suit',
  'TROUSER': 'trouser',
  'TUXEDO': 'tuxedo',
  'TUXEDO_JACKET': 'tuxedo_jacket',
  'TUXEDO_SHIRT': 'tuxedo_shirt',
  'TUXEDO_TROUSER': 'tuxedo_trouser',
  'TUXEDO_WAISTCOAT': 'tuxedo_waistcoat',
  'WAISTCOAT': 'waistcoat',
  'SUIT_EXTRA_TROUSER': 'suit_extra_trouser',
  'SUIT_JACKET': 'suit_jacket',
  'SUIT_TROUSER': 'suit_trouser',
  'SUIT_WAISTCOAT': 'suit_waistcoat',
  'TUXEDO_EXTRA_TUXEDO_TROUSER': 'tuxedo_extra_tuxedo_trouser',
  'TUXEDO_TUXEDO_JACKET': 'tuxedo_tuxedo_jacket',
  'TUXEDO_TUXEDO_TROUSER': 'tuxedo_tuxedo_trouser',
  'TUXEDO_TUXEDO_WAISTCOAT': 'tuxedo_tuxedo_waistcoat',
} as const;
export type ConfiguratorTypeType = typeof ConfiguratorType;
export type ConfiguratorTypeValueType = ConfiguratorTypeType[keyof ConfiguratorTypeType];

export const CmSelectedView = {
  'MODEL_VIEW': 'model_view',
  'PRODUCT_VIEW': 'product_view',
} as const;
export type CmSelectedViewType = typeof CmSelectedView;
export type CmSelectedViewValueType = CmSelectedViewType[keyof CmSelectedViewType];

export const OverlayStep = {
  'FABRIC': 'fabric',
  'FIT': 'fit',
  'INTRO': 'intro',
  'PERSONALIZE': 'personalize',
  'STYLE': 'style',
} as const;
export type OverlayStepType = typeof OverlayStep;
export type OverlayStepValueType = OverlayStepType[keyof OverlayStepType];

export const CmLiteFit = {
  'SLIM': 'slim',
  'STRAIGHT': 'straight',
  'WIDE': 'wide',
} as const;
export type CmLiteFitType = typeof CmLiteFit;
export type CmLiteFitValueType = CmLiteFitType[keyof CmLiteFitType];

export const ConfiguratorSection = {
  'COAT_BASE_STYLE': 'coat_base_style',
  'COAT_OPTIONS': 'coat_options',
  'EXTRA_TROUSER_BASE_STYLE': 'extra_trouser_base_style',
  'EXTRA_TROUSER_OPTIONS': 'extra_trouser_options',
  'EXTRA_TUXEDO_TROUSER_BASE_STYLE': 'extra_tuxedo_trouser_base_style',
  'EXTRA_TUXEDO_TROUSER_OPTIONS': 'extra_tuxedo_trouser_options',
  'FABRIC': 'fabric',
  'JACKET_BASE_STYLE': 'jacket_base_style',
  'JACKET_OPTIONS': 'jacket_options',
  'SHIRT_BASE_STYLE': 'shirt_base_style',
  'SHIRT_OPTIONS': 'shirt_options',
  'SUMMARY': 'summary',
  'TROUSERS_BASE_STYLE': 'trousers_base_style',
  'TROUSERS_OPTIONS': 'trousers_options',
  'TUXEDO_JACKET_BASE_STYLE': 'tuxedo_jacket_base_style',
  'TUXEDO_JACKET_OPTIONS': 'tuxedo_jacket_options',
  'TUXEDO_SHIRT_BASE_STYLE': 'tuxedo_shirt_base_style',
  'TUXEDO_SHIRT_OPTIONS': 'tuxedo_shirt_options',
  'TUXEDO_TROUSER_BASE_STYLE': 'tuxedo_trouser_base_style',
  'TUXEDO_TROUSER_OPTIONS': 'tuxedo_trouser_options',
  'TUXEDO_WAISTCOAT_BASE_STYLE': 'tuxedo_waistcoat_base_style',
  'TUXEDO_WAISTCOAT_OPTIONS': 'tuxedo_waistcoat_options',
  'WAISTCOAT_BASE_STYLE': 'waistcoat_base_style',
  'WAISTCOAT_OPTIONS': 'waistcoat_options',
} as const;
export type ConfiguratorSectionType = typeof ConfiguratorSection;
export type ConfiguratorSectionValueType = ConfiguratorSectionType[keyof ConfiguratorSectionType];

export const CmUserFlow = {
  'CLONE': 'clone',
  'CUSTOMIZE_FLOW_PDP': 'customize_flow_pdp',
  'CUSTOMIZE_FLOW_SIZE_PICKER': 'customize_flow_size_picker',
  'FINISH_IN_STORE': 'finish_in_store',
  'NORMAL': 'normal',
  'REORDER': 'reorder',
  'SAVE_FOR_LATER': 'save_for_later',
} as const;
export type CmUserFlowType = typeof CmUserFlow;
export type CmUserFlowValueType = CmUserFlowType[keyof CmUserFlowType];

export const LoggedIn = {
  'FALSE': 'false',
  'TRUE': 'true',
} as const;
export type LoggedInType = typeof LoggedIn;
export type LoggedInValueType = LoggedInType[keyof LoggedInType];

export const CmItemType = {
  'BASE_STYLE': 'base_style',
  'FABRIC': 'fabric',
  'OPTION': 'option',
  'OPTION_ADVANCED': 'option_advanced',
  'OPTION_GROUP': 'option_group',
  'OPTION_GROUP_ADVANCED': 'option_group_advanced',
  'PRODUCT': 'product',
  'FILTER': 'filter',
} as const;
export type CmItemTypeType = typeof CmItemType;
export type CmItemTypeValueType = CmItemTypeType[keyof CmItemTypeType];

export const EventCategory = {
  'CHECKOUT_INTERACTIONS': 'checkout_interactions',
  'PLP_INTERACTIONS': 'plp_interactions',
  'PDP_INTERACTIONS': 'pdp_interactions',
  'GLOBAL_INTERACTIONS': 'global_interactions',
  'FOOTER_INTERACTIONS': 'footer_interactions',
  'JOURNAL_INTERACTIONS': 'journal_interactions',
  'CM_INTERACTIONS': 'cm_interactions',
  'LOOKBUILDER_INTERACTIONS': 'lookbuilder_interactions',
  'INSTORE_INTERACTIONS': 'instore_interactions',
  'ECOMMERCE_INTERACTIONS': 'ecommerce_interactions',
  'BTC_INTERACTIONS': 'btc_interactions',
  'BOOKING_INTERACTIONS': 'booking_interactions',
  'LOGIN_INTERACTIONS': 'login_interactions',
  'SP_INTERACTIONS': 'sp_interactions',
  'CONFIGURATOR_INTERACTIONS': 'configurator_interactions',
  'RETURNING_ITEM_INTERACTIONS': 'returning_item_interactions',
} as const;
export type EventCategoryType = typeof EventCategory;
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType];

export const Language = {
  'DE': 'de',
  'EN': 'en',
  'ES': 'es',
  'FR': 'fr',
  'IT': 'it',
  'KO': 'ko',
  'NL': 'nl',
  'PL': 'pl',
  'SV': 'sv',
  'ZH': 'zh',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const PageType = {
  'ACCOUNT': 'account',
  'BLACK_TIE_CONFIGURATOR': 'black-tie-configurator',
  'BLACK_TIE_CONFIGURATOR': 'black_tie_configurator',
  'BOOKING_TOOL': 'booking_tool',
  'CART': 'cart',
  'CATEGORY': 'category',
  'CATEGORY_LANDING': 'category_landing',
  'CHECKOUT': 'checkout',
  'CUSTOMMADE': 'custommade',
  'EMPLOYEE_PROFILE': 'employee_profile',
  'ERROR': 'error',
  'GIFTCARD': 'giftcard',
  'HOME': 'home',
  'INSTORE': 'instore',
  'JOURNAL': 'journal',
  'LOGIN': 'login',
  'LOOKBUILDER': 'lookbuilder',
  'MINI_CART': 'mini-cart',
  'ORDER_CONFIRMATION': 'order_confirmation',
  'PRODUCT': 'product',
  'PRODUCT_DETAIL_PAGE': 'product_detail_page',
  'PRODUCT_LIST_PAGE': 'product_list_page',
  'RETURN': 'return',
  'RETURN_CONFIRMATION': 'return_confirmation',
  'STORE': 'store',
  'STORE_DETAILS': 'store_details',
  'STORE_LOCATOR': 'store_locator',
  'STORE_OVERVIEW': 'store_overview',
  'SUPPORT': 'support',
  'WISHLIST': 'wishlist',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const CmLiteVariantFit = {
  'STRAIGHT': 'straight',
  'TAPERED': 'tapered',
} as const;
export type CmLiteVariantFitType = typeof CmLiteVariantFit;
export type CmLiteVariantFitValueType = CmLiteVariantFitType[keyof CmLiteVariantFitType];

export const Affiliation = {
  'WEBSTORE_EUR': 'webstore-eur',
  'WEBSTORE_USD': 'webstore-usd',
  'WEBSTORE_CAD': 'webstore-cad',
  'WEBSTORE_PLN': 'webstore-pln',
  'WEBSTORE_AUD': 'webstore-aud',
  'WEBSTORE_SEK': 'webstore-sek',
  'WEBSTORE_CHF': 'webstore-chf',
  'WEBSTORE_DKK': 'webstore-dkk',
  'WEBSTORE_AED': 'webstore-aed',
  'WEBSTORE_NOK': 'webstore-nok',
  'WEBSTORE_CNY': 'webstore-cny',
  'WEBSTORE_SGD': 'webstore-sgd',
  'WEBSTORE_HKD': 'webstore-hkd',
  'WEBSTORE_GBP': 'webstore-gbp',
  'WEBSTORE_KRW': 'webstore-krw',
} as const;
export type AffiliationType = typeof Affiliation;
export type AffiliationValueType = AffiliationType[keyof AffiliationType];

export const Brand = {
  'SUITSUPPLY': 'suitsupply',
} as const;
export type BrandType = typeof Brand;
export type BrandValueType = BrandType[keyof BrandType];

export const SaveMethod = {
  'FINISH_IN_STORE': 'finish_in_store',
  'SAVE_FOR_LATER': 'save_for_later',
} as const;
export type SaveMethodType = typeof SaveMethod;
export type SaveMethodValueType = SaveMethodType[keyof SaveMethodType];

export const SelectedCategory = {
  'COAT': 'coat',
  'EXTRA_TROUSER': 'extra_trouser',
  'EXTRA_TUXEDO_TROUSER': 'extra_tuxedo_trouser',
  'FABRIC': 'fabric',
  'JACKET': 'jacket',
  'SHIRT': 'shirt',
  'STYLE': 'style',
  'SUMMARY': 'summary',
  'TROUSERS': 'trousers',
  'TUXEDO_JACKET': 'tuxedo_jacket',
  'TUXEDO_SHIRT': 'tuxedo_shirt',
  'TUXEDO_TROUSER': 'tuxedo_trouser',
  'TUXEDO_WAISTCOAT': 'tuxedo_waistcoat',
  'WAISTCOAT': 'waistcoat',
} as const;
export type SelectedCategoryType = typeof SelectedCategory;
export type SelectedCategoryValueType = SelectedCategoryType[keyof SelectedCategoryType];

export const Country = {
  'AE': 'ae',
  'AT': 'at',
  'AU': 'au',
  'BE': 'be',
  'BG': 'bg',
  'BN': 'bn',
  'CA': 'ca',
  'CH': 'ch',
  'CN': 'cn',
  'CY': 'cy',
  'CZ': 'cz',
  'DE': 'de',
  'DK': 'dk',
  'DO': 'do',
  'EE': 'ee',
  'ES': 'es',
  'FI': 'fi',
  'FR': 'fr',
  'GB': 'gb',
  'GH': 'gh',
  'GI': 'gi',
  'GP': 'gp',
  'GR': 'gr',
  'GW': 'gw',
  'HK': 'hk',
  'HR': 'hr',
  'HU': 'hu',
  'IE': 'ie',
  'IN': 'in',
  'IR': 'ir',
  'IS': 'is',
  'IT': 'it',
  'JE': 'je',
  'JP': 'jp',
  'KR': 'kr',
  'LI': 'li',
  'LT': 'lt',
  'LU': 'lu',
  'LV': 'lv',
  'LY': 'ly',
  'MC': 'mc',
  'MO': 'mo',
  'MQ': 'mq',
  'MT': 'mt',
  'MV': 'mv',
  'MY': 'my',
  'NL': 'nl',
  'NO': 'no',
  'PL': 'pl',
  'PR': 'pr',
  'PT': 'pt',
  'QA': 'qa',
  'RO': 'ro',
  'SE': 'se',
  'SG': 'sg',
  'SI': 'si',
  'SK': 'sk',
  'TT': 'tt',
  'US': 'us',
} as const;
export type CountryType = typeof Country;
export type CountryValueType = CountryType[keyof CountryType];

export const Currency = {
  'EUR': 'eur',
  'USD': 'usd',
  'CNY': 'cny',
  'AUD': 'aud',
  'BGN': 'bgn',
  'CAD': 'cad',
  'CZK': 'czk',
  'DKK': 'dkk',
  'HKD': 'hkd',
  'HUF': 'huf',
  'ISK': 'isk',
  'INR': 'inr',
  'JPY': 'jpy',
  'CHF': 'chf',
  'MOP': 'mop',
  'MYR': 'myr',
  'NOK': 'nok',
  'QAR': 'qar',
  'RON': 'ron',
  'SGD': 'sgd',
  'SEK': 'sek',
  'AED': 'aed',
  'GBP': 'gbp',
  'PLN': 'pln',
  'KRW': 'krw',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const Creative = {
  'HOMEPAGE_ADBLOCK': 'homepage_adblock',
  'HOMEPAGE_RELATED_ARTICLE': 'homepage_related-article',
  'HOMEPAGE_USP': 'homepage_usp',
  'HOMEPAGE_TEXTLINK': 'homepage_textlink',
  'HOMEPAGE_SEOBLOCK': 'homepage_seoblock',
  'FOOTER_LINK': 'footer_link',
  'FOOTER_USP': 'footer_usp',
  'PLP_HEADER': 'plp_header',
  'PLP_ADBLOCK': 'plp_adblock',
  'PLP_WIDGET': 'plp_widget',
  'JOURNAL_HUB_RELATED_ARTICLES': 'journal-hub_related-articles',
  'JOURNAL_HUB_ADBLOCK': 'journal-hub_adblock',
  'JOURNAL_HUB_HEADER': 'journal-hub_header',
  'JOURNAL_BUTTONLINK': 'journal_buttonlink',
  'JOURNAL_ADBLOCK': 'journal_adblock',
  'JOURNAL_TEXTLINK': 'journal_textlink',
  'PDP_ACCORDION': 'pdp_accordion',
  'PDP_EMBEDDED_ARTICLE': 'pdp_embedded-article',
  'PDP_USP': 'pdp_usp',
  'PDP_RELATED_ARTICLES': 'pdp_related-articles',
  'PDP_BUTTONLINK': 'pdp_buttonlink',
  'PDP_PANEL': 'pdp_panel',
  'STORE_TEXTLINK': 'store_textlink',
  'STORE_ADBLOCK': 'store_adblock',
  'STORE_FAQLINK': 'store_faqlink',
  'STORE_OVERVIEW_TEXTLINK': 'store-overview_textlink',
  'STORE_SEARCH_TEXTLINK': 'store-search_textlink',
  'STORE_SEARCH_SLIDER_TEXTLINK': 'store-search_slider-textlink',
  'STORE_SEARCH_ADBLOCK': 'store-search_adblock',
  'PDP_PANEL_WISHLIST': 'pdp_panel_wishlist',
  'PLP_PANEL_WISHLIST': 'plp_panel_wishlist',
  'PDP_BUTTONLINK_MWTW': 'pdp_buttonlink_mwtw',
  'PDP_PANEL_MWTW': 'pdp_panel_mwtw',
  'PDP_USP_MWTW': 'pdp_usp_mwtw',
  'PDP_PANEL_SA': 'pdp_panel_sa',
  'FOOTER_PANEL_SA': 'footer_panel_sa',
  'PANEL_MINICART': 'panel_minicart',
  'LOOKBUILDER_SUMMARY_ADBLOCK': 'lookbuilder-summary_adblock',
  'SHOP_THE_LOOK_USP': 'shop-the-look_usp',
  'SHOP_THE_LOOK_PANEL': 'shop-the-look_panel',
  'PDP_ICONLINK_MWTW': 'pdp_iconlink_mwtw',
  'CLP_ADBLOCK': 'clp_adblock',
  'CLP_BUTTONLINK': 'clp_buttonlink',
  'STORE_DETAILS': 'store_details',
  'STORE_LOCATOR': 'store_locator',
  'STORE_OVERVIEW': 'store_overview',
  'PDP_SHOPTHELOOK_BUTTON': 'pdp_shopthelook_button',
  'CM_SIZE_PASSPORT': 'cm_size_passport',
  'CM_SUMMARY_PANEL': 'cm_summary_panel',
} as const;
export type CreativeType = typeof Creative;
export type CreativeValueType = CreativeType[keyof CreativeType];

export const ApplicationId = {
  'CUSTOM_MADE': 'custom_made',
} as const;
export type ApplicationIdType = typeof ApplicationId;
export type ApplicationIdValueType = ApplicationIdType[keyof ApplicationIdType];

export const PreviousCategory = {
  'COAT': 'coat',
  'EXTRA_TROUSER': 'extra_trouser',
  'EXTRA_TUXEDO_TROUSER': 'extra_tuxedo_trouser',
  'FABRIC': 'fabric',
  'JACKET': 'jacket',
  'SHIRT': 'shirt',
  'STYLE': 'style',
  'SUMMARY': 'summary',
  'TROUSERS': 'trousers',
  'TUXEDO_JACKET': 'tuxedo_jacket',
  'TUXEDO_SHIRT': 'tuxedo_shirt',
  'TUXEDO_TROUSER': 'tuxedo_trouser',
  'TUXEDO_WAISTCOAT': 'tuxedo_waistcoat',
  'WAISTCOAT': 'waistcoat',
} as const;
export type PreviousCategoryType = typeof PreviousCategory;
export type PreviousCategoryValueType = PreviousCategoryType[keyof PreviousCategoryType];

let sysApplicationId: any;
let sysVersion: any;
let sysAffiliateMarker: any;
let sysAwc: any;
let sysCountry: any;
let sysLanguage: any;
let sysLocationId: any;
let sysUserId: any;
let sysLoggedIn: any;
let sysPageType: any;
let sysGaClientId: any;
let sysGaSessionId: any;
let sysGaSessionNumber: any;
let sysFbFbp: any;
let sysFbFbc: any;
let sysGaAwClid: any;
let sysTtclid: any;
let sysMsclkid: any;
let sysTwclid: any;
let sysRdtCid: any;
let sysEpik: any;

export function setSystemProperties(properties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string;
    awc: string;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string;
    fbFbc: string;
    gaAwClid: string;
    ttclid: string;
    msclkid: string;
    twclid: string;
    rdtCid: string;
    epik: string}) {
  if (properties.applicationId !== null && properties.applicationId !== undefined) {
    sysApplicationId = properties.applicationId;
  }
  if (properties.version !== null && properties.version !== undefined) {
    sysVersion = properties.version;
  }
  if (properties.affiliateMarker !== null && properties.affiliateMarker !== undefined) {
    sysAffiliateMarker = properties.affiliateMarker;
  }
  if (properties.awc !== null && properties.awc !== undefined) {
    sysAwc = properties.awc;
  }
  if (properties.country !== null && properties.country !== undefined) {
    sysCountry = properties.country;
  }
  if (properties.language !== null && properties.language !== undefined) {
    sysLanguage = properties.language;
  }
  if (properties.locationId !== null && properties.locationId !== undefined) {
    sysLocationId = properties.locationId;
  }
  if (properties.userId !== null && properties.userId !== undefined) {
    sysUserId = properties.userId;
  }
  if (properties.loggedIn !== null && properties.loggedIn !== undefined) {
    sysLoggedIn = properties.loggedIn;
  }
  if (properties.pageType !== null && properties.pageType !== undefined) {
    sysPageType = properties.pageType;
  }
  if (properties.gaClientId !== null && properties.gaClientId !== undefined) {
    sysGaClientId = properties.gaClientId;
  }
  if (properties.gaSessionId !== null && properties.gaSessionId !== undefined) {
    sysGaSessionId = properties.gaSessionId;
  }
  if (properties.gaSessionNumber !== null && properties.gaSessionNumber !== undefined) {
    sysGaSessionNumber = properties.gaSessionNumber;
  }
  if (properties.fbFbp !== null && properties.fbFbp !== undefined) {
    sysFbFbp = properties.fbFbp;
  }
  if (properties.fbFbc !== null && properties.fbFbc !== undefined) {
    sysFbFbc = properties.fbFbc;
  }
  if (properties.gaAwClid !== null && properties.gaAwClid !== undefined) {
    sysGaAwClid = properties.gaAwClid;
  }
  if (properties.ttclid !== null && properties.ttclid !== undefined) {
    sysTtclid = properties.ttclid;
  }
  if (properties.msclkid !== null && properties.msclkid !== undefined) {
    sysMsclkid = properties.msclkid;
  }
  if (properties.twclid !== null && properties.twclid !== undefined) {
    sysTwclid = properties.twclid;
  }
  if (properties.rdtCid !== null && properties.rdtCid !== undefined) {
    sysRdtCid = properties.rdtCid;
  }
  if (properties.epik !== null && properties.epik !== undefined) {
    sysEpik = properties.epik;
  }
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {applicationId: ApplicationIdValueType;
    version: string;
    affiliateMarker: string;
    awc: string;
    country: CountryValueType;
    language: LanguageValueType;
    locationId: string;
    userId: string;
    loggedIn: LoggedInValueType;
    pageType: PageTypeValueType;
    gaClientId: string;
    gaSessionId: string;
    gaSessionNumber: string;
    fbFbp: string;
    fbFbc: string;
    gaAwClid: string;
    ttclid: string;
    msclkid: string;
    twclid: string;
    rdtCid: string;
    epik: string},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }
    
    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, "4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG");
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPrice(price: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("5RMsvPEmT", _label ? "price" + ': ' + _label : "price", price));
  messages = messages.concat(AvoAssert.assertMin("5RMsvPEmT", _label ? "price" + ": " + _label : "price", 0.000000, price));
  return messages;
}

function assertValue(value: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("Kddfsr3Xx", _label ? "value" + ': ' + _label : "value", value));
  messages = messages.concat(AvoAssert.assertMin("Kddfsr3Xx", _label ? "value" + ": " + _label : "value", 0.000000, value));
  return messages;
}

function assertQuantity(quantity: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("fg1kaNXr_", _label ? "quantity" + ': ' + _label : "quantity", quantity));
  messages = messages.concat(AvoAssert.assertMin("fg1kaNXr_", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
  return messages;
}

function assertPosition(position: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("pBPbnpdFj", _label ? "position" + ': ' + _label : "position", position));
  messages = messages.concat(AvoAssert.assertMin("pBPbnpdFj", _label ? "position" + ": " + _label : "position", 1, position));
  return messages;
}

function assertPositionOptional(position: number | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (position !== undefined && position !== null) {
    messages = messages.concat(AvoAssert.assertInt("pBPbnpdFj", _label ? "position" + ': ' + _label : "position", position));
    messages = messages.concat(AvoAssert.assertMin("pBPbnpdFj", _label ? "position" + ": " + _label : "position", 1, position));
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface ProductViewedProperties {
  listId: string | null | undefined;
  itemListName: string | null | undefined;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  variant: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  includedAlterations: boolean;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  sliderImageNumber: number;
  isCmLite: boolean;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Product Viewed: When landing an a PDP, or clicking on 'select size' in panel
 * 
 * When to trigger this event:
 * 1. When clicking on 'Select Size' in the 'Shop the Look' panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4a040kO3L/trigger/biZR2zvCbF
 * 
 * @param properties the properties associated with this event
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4a040kO3L}
 */
export function productViewed(properties: ProductViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.listId !== undefined && properties.listId !== null ?
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId}) :
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: null});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  properties.variant !== undefined && properties.variant !== null ?
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant}) :
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  properties.sizePassportFitBucket !== undefined && properties.sizePassportFitBucket !== null ?
    eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket}) :
    eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4a040kO3L", "bbcf70074bac4b1520c9a6f14c7c1afb39efd0b46dffe5ae2ace04b922618c08", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4a040kO3L", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "4a040kO3L", "bbcf70074bac4b1520c9a6f14c7c1afb39efd0b46dffe5ae2ace04b922618c08");
    }
    // destination Segment
    Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductViewedCmProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  listId: string | null | undefined;
  itemListName: string | null | undefined;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  sku: string;
  value: number;
  includedAlterations: boolean;
  sliderImageNumber: number;
  currency: CurrencyValueType | null | undefined;
  hasSizepassport: boolean | null | undefined;
  hasUsedSizepassport: boolean | null | undefined;
}
/**
 * Product Viewed: When landing an a PDP, or clicking on 'select size' in panelvariant description: When the user is going to Configuration summary page and sees the configured product - only on summary page (do not send on configurator steps)
 *  for each product (e.g. for the suit it should be 2 separate events - for Jacket and for Trousers).
 * Propertires:
 * "configurator_type": "suit -jacket|trousers",
 * "configurator_section": "fabric|style|basic_options|summary",
 * 
 * When to trigger this event:
 * 1. When the user is going to Configuration summary page and sees the configured product.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4a040kO3L.JcE5rZjJL/trigger/t3pirD35vxFs79od4tmHD
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.value: Price * Quantity
 * @param properties.includedAlterations: This property indicates whether the user selected the alterations available in the Size Passport to be included in the product. A true value confirms that the product is a custom size. A false value confirms that the product is a standard size.
 * Note (Aug 2026): currently scoped to trousers only — on product_added, true only ever appears with category = trousers, even though the property itself is populated across ~89% of add-to-bag events. Update this note if Size Passport alterations expand to other categories.
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4a040kO3L.JcE5rZjJL}
 */
export function productViewedCm(properties: ProductViewedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.listId !== undefined && properties.listId !== null ?
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId}) :
    eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: null});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "GjML-ubj3ekTomHsZWczH", name: "included_alterations", value: properties.includedAlterations});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  properties.hasSizepassport !== undefined && properties.hasSizepassport !== null ?
    eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport}) :
    eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: null});
  properties.hasUsedSizepassport !== undefined && properties.hasUsedSizepassport !== null ?
    eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport}) :
    eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4a040kO3L.JcE5rZjJL", "9dd49615445db6e1d57bf5457748a89d81e501aaeea0307496f68af3746e4b41", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4a040kO3L.JcE5rZjJL", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "4a040kO3L.JcE5rZjJL", "9dd49615445db6e1d57bf5457748a89d81e501aaeea0307496f68af3746e4b41");
    }
    // destination Segment
    Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  listId: string;
  itemListName: string | null | undefined;
  productId: string;
  category: string;
  affiliation: AffiliationValueType;
  name: string | null | undefined;
  variant: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  value: number;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  sku: string;
  fullLook: string | null | undefined;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  sliderImageNumber: number;
  isCmLite: boolean;
  cmLiteFit: CmLiteFitValueType;
  cmLiteVariantFit: CmLiteVariantFitValueType;
  deliveryDays: string | null | undefined;
  cmLiteFabricAvailable: boolean;
  sizePassportFitBucket: string | null | undefined;
  flowId: string | null | undefined;
  sizePassportId: string;
  isDefaultSelection: boolean | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Product Added: When clicking on 'add to bag' on a PDP, panel or increasing value on the cart page. 
 * for Custommade: when clicking on 'add to bag' on the summary screen
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.value: Price * Quantity
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
 * - havana
 * - milano
 * - roma
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.sliderImageNumber: This property pinpoints the exact product image visible on the product placeholder at the time of interaction. Its main function is to offer valuable data on user engagement with the product image slider. By capturing which image was displayed during an interaction, we can analyze if, and how, users are utilizing this feature, ultimately informing design improvements and optimizing user experience.
 * @param properties.isCmLite: This property describes if the product has custom made lite fits enabled. Default as false.
 * @param properties.cmLiteFit: This property describes the option chosen for the Custom Made Lite Fit.
 * @param properties.cmLiteVariantFit: This property describes the option chosen for the Custom Made Lite Variant Fit.
 * @param properties.deliveryDays: This property represents delivery days in a delivery promise message, e.g 'Delivery 1-2 weeks' for CM Lite products
 * @param properties.cmLiteFabricAvailable: This property describes if for that product the Custom Made lite fabric is available.
 * @param properties.sizePassportFitBucket: Property that indicates the original fit bucket, where the Size Passport was created. We want to enable tracking of whether the Size Passport recommendation was used within the same fit bucket or across different fit buckets. This will allow us to compare it against the fit of the garment ultimately purchased. Values come from raw.measurements__fit.bucket, e.g. 'Fit Bucket Milano'.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.sizePassportId: Identifier of the size passport (profile) used for the selected size.
 * @param properties.isDefaultSelection: True when the size was selected automatically by the size passport default (recommended size) rather than picked by the user.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/0mNPEK9jV}
 */
export function productAdded(properties: ProductAddedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  properties.variant !== undefined && properties.variant !== null ?
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant}) :
    eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
    eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
  properties.fitId !== undefined && properties.fitId !== null ?
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
    eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  properties.fullLook !== undefined && properties.fullLook !== null ?
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
    eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  eventPropertiesArray.push({id: "xmEpd00WyoeakoDq0l-G2", name: "slider_image_number", value: properties.sliderImageNumber});
  eventPropertiesArray.push({id: "Gjk39Ttu4rGWlVqmFNqHc", name: "is_cm_lite", value: properties.isCmLite});
  eventPropertiesArray.push({id: "1xHOBGzmtwwRjmoGvQ0xv", name: "cm_lite_fit", value: properties.cmLiteFit});
  eventPropertiesArray.push({id: "aPF56O3f7O5JoMSXmzHju", name: "cm_lite_variant_fit", value: properties.cmLiteVariantFit});
  properties.deliveryDays !== undefined && properties.deliveryDays !== null ?
    eventPropertiesArray.push({id: "in2NkIW7WHc6aGBxP1jd2", name: "delivery_days", value: properties.deliveryDays}) :
    eventPropertiesArray.push({id: "in2NkIW7WHc6aGBxP1jd2", name: "delivery_days", value: null});
  eventPropertiesArray.push({id: "AGoi3z0CZHAYb7XFn_W66", name: "cm_lite_fabric_available", value: properties.cmLiteFabricAvailable});
  properties.sizePassportFitBucket !== undefined && properties.sizePassportFitBucket !== null ?
    eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: properties.sizePassportFitBucket}) :
    eventPropertiesArray.push({id: "ezR_7-4smAYg-g5bsWCXd", name: "size_passport_fit_bucket", value: null});
  properties.flowId !== undefined && properties.flowId !== null ?
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId}) :
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: null});
  eventPropertiesArray.push({id: "CTj9-O3uekuhdzyH2PLo4", name: "size_passport_id", value: properties.sizePassportId});
  properties.isDefaultSelection !== undefined && properties.isDefaultSelection !== null ?
    eventPropertiesArray.push({id: "WqKJi1qIS2p8xywg3bOnt", name: "is_default_selection", value: properties.isDefaultSelection}) :
    eventPropertiesArray.push({id: "WqKJi1qIS2p8xywg3bOnt", name: "is_default_selection", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0mNPEK9jV", "f3c84eb7d712f060c685d583e8c861ee82d6cf7ab9a9d4fe1e0c1e5dc2a14fb2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0mNPEK9jV", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "0mNPEK9jV", "f3c84eb7d712f060c685d583e8c861ee82d6cf7ab9a9d4fe1e0c1e5dc2a14fb2");
    }
    // destination Segment
    Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedCmProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  listId: string;
  itemListName: string | null | undefined;
  productId: string;
  name: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  value: number;
  sku: string;
  hasSizepassport: boolean;
  hasUsedSizepassport: boolean;
  flowId: string | null | undefined;
  sizePassportId: string;
  isDefaultSelection: boolean | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Product Added: When clicking on 'add to bag' on a PDP, panel or increasing value on the cart page. 
 * for Custommade: when clicking on 'add to bag' on the summary screenvariant description: for Custommade: when clicking on 'add to bag' on the summary screen
 * Event should be sent for each product (e.g. for the suit it should be 2 separate events - for Jacket and for Trousers). 
 * 
 * When to trigger this event:
 * 1. When clicking on 'add to bag' on the summary screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/0mNPEK9jV.z_P3ped11V1lKwRHv88Jl/trigger/Dt7jZgnEj2Mrm70vDTGLK
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.
 * For custom-made products, it's: custom-made.
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: `product_id` from the current PDP
 * 2.  Shop the Look slider (MWTW) on PDP: `look_id`
 * 3.  Shop the Look wishlist panel: `product_id` from the current PDP
 * 4.  Shop the Look from minicart: `product_id` from the current PDP
 * 5.  Shop the Look landing page: `look_id`
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.
 * For custom-made
 * 1. 'custom made'
 * For Shop the Look components:
 * 1.  Shop the Look hero on PDP: shop_the_look_hero
 * 2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
 * 3.  Shop the Look wishlist panel: shop_the_look_wishlist
 * 4.  Shop the Look from minicart: shop_the_look_minicart
 * 5.  Shop the Look landing page: shop_the_look_sbl
 * For custom made lite: ''custom made lite''
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.value: Price * Quantity
 * @param properties.sku: SKU of product, same as product_id
 * For CM Lite: sku should contain selected RTW code or 'cm_trousers' for CM fits or RTW fits out of stock
 * @param properties.hasSizepassport: Whether the customer has a size passport.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true only appears with category = trousers there. The custom_made app source also sets it true broadly but never populates category, so it can't be sliced by product type. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * Note (Aug 2026): currently scoped to trousers only on the webstore/shopify-storefront sources — on product_added, true is overwhelmingly category = trousers, with a thin tail elsewhere. Update this note if Size Passport alterations expand to other categories on webstore.
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.sizePassportId: Identifier of the size passport (profile) used for the selected size.
 * @param properties.isDefaultSelection: True when the size was selected automatically by the size passport default (recommended size) rather than picked by the user.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/0mNPEK9jV.z_P3ped11V1lKwRHv88Jl}
 */
export function productAddedCm(properties: ProductAddedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
  properties.itemListName !== undefined && properties.itemListName !== null ?
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
    eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
  eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
  eventPropertiesArray.push({id: "N05TvU18S", name: "has_sizepassport", value: properties.hasSizepassport});
  eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
  properties.flowId !== undefined && properties.flowId !== null ?
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId}) :
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: null});
  eventPropertiesArray.push({id: "CTj9-O3uekuhdzyH2PLo4", name: "size_passport_id", value: properties.sizePassportId});
  properties.isDefaultSelection !== undefined && properties.isDefaultSelection !== null ?
    eventPropertiesArray.push({id: "WqKJi1qIS2p8xywg3bOnt", name: "is_default_selection", value: properties.isDefaultSelection}) :
    eventPropertiesArray.push({id: "WqKJi1qIS2p8xywg3bOnt", name: "is_default_selection", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPrice(properties.price));
    messages = messages.concat(assertQuantity(properties.quantity));
    messages = messages.concat(assertPosition(properties.position));
    messages = messages.concat(assertValue(properties.value));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0mNPEK9jV.z_P3ped11V1lKwRHv88Jl", "6d0d88c937a9522a2f0d61756d5496243cf3e0448ba345e4d7c437b4ca6404c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0mNPEK9jV.z_P3ped11V1lKwRHv88Jl", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "0mNPEK9jV.z_P3ped11V1lKwRHv88Jl", "6d0d88c937a9522a2f0d61756d5496243cf3e0448ba345e4d7c437b4ca6404c3");
    }
    // destination Segment
    Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageLoadedProperties {
  customDestinationPageName_: string;
  localeVisited: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed
 * 
 * When to trigger this event:
 * 1. Custommade Suits page 1:

url: 
suitsupply.com/custommade/suit/fabric
location_id: suitsupply.com/en-nl/custommade/suit/fabric
title: "Select your fabric"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/ilo2Fao9X
 * 2. Custommade Suits - jacket:

url: 
suitsupply.com/custommade/suit/jacket
location_id: suitsupply.com/en-nl/custommade/suit/jacket
title: "Customize your jacket"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/EJGPRxCWM
 * 3. Custommade Suits - jacket - Style:

url: 
suitsupply.com/custommade/suit/jacket/style
location_id: suitsupply.com/en-nl/custommade/suit/jacket/style
title: customize your jacket style
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/8DnMiHdiv
 * 4. Custommade Suits - trousers - Style:

url: 
suitsupply.com/custommade/suit/trousers/style
location_id: suitsupply.com/en-nl/custommade/suit/trousers/style
title: customize your trousers style
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/Y-U_FnScC
 * 5. Custommade Suits - trousers:

url: 
suitsupply.com/custommade/suit/trousers
location_id: suitsupply.com/en-nl/custommade/suit/trousers
title: "Customize your trousers"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/lDHJUY7uw
 * 6. Custommade Suits - Waistcoat:

url: 
suitsupply.com/custommade/suit/waistcoat
location_id: suitsupply.com/en-nl/custommade/suit/waistcoat
title: "Customize your waistcoat"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/hGYSO6MWH
 * 7. Custommade Suits - summary

url: 
suitsupply.com/custommade/suit/summary/
location_id: suitsupply.com/en-nl/custommade/suit/summary/
title: "Your summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/tB6E44bgl
 * 8. Title: instore - checkin - login
url: https://suitsupply.com/en-nl//instore/checkin-login/
location_id: https://suitsupply.com/en-nl//instore/checkin-login/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/GzKmdfzMs
 * 9. title: instore - checkin - register
location_id: https://suitsupply.com/en-nl/instore/checkin-register/
url: https://suitsupply.com/instore/checkin-register/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/h5T0sz4zf
 * 10. title: instore - checkin - long succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-long/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-long/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/WL4lVMb0g
 * 11. title: instore - checkin - short succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-short/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-short/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226/trigger/Djt5Cknvx
 * 
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226}
 */
export function pageLoaded(properties: PageLoadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4l0ZskS226", "9909bd3c2491ac35c51c1277735091102ed9e25e9dead3b5ec255902533a6a64", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4l0ZskS226", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedCmProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  customDestinationPageName_: string;
  localeVisited: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not neededvariant description: Only when the configurator is loaded at the first time and on the Summary page.
 * Properties:
 * "configurator_type": "suit|trousers",
 * "configurator_section": "fabric|jacket_base_style|jacket_options|summary",
 * 
 * When to trigger this event:
 * 1. Configurator page is loaded when user navigates to configurator from other pages 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226.L14A1aHRF/trigger/jc7VzmdaB6PvLj_S4TUSh
 * 2. When the configurator is loaded on the Summary page.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226.L14A1aHRF/trigger/PsEYKZuKlH2vOl159nw7G
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/4l0ZskS226.L14A1aHRF}
 */
export function pageLoadedCm(properties: PageLoadedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4l0ZskS226.L14A1aHRF", "d8c853452896320b63bcb4aaf5709f1c4fdcb00a4030832b5a0fb6d5dbe79e7d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4l0ZskS226.L14A1aHRF", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface PromotionViewedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string | null | undefined;
  promotionId: string;
  name: string | null | undefined;
  creative: CreativeValueType;
  position: number;
  shopTheLookId: string;
  storeName: string | null | undefined;
  locationCode: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Promotion Viewed: When a promotion is being shown in the viewport 
 * Only add the 'products' object, if there are products in the promotion.
 * Links that open the booking tool always send name = booking_tool and promotion_id = booking_tool_<entry point>, where <entry point> is the same value as event_location on book_store_appointment_clicked (e.g. booking_tool_store_card). Filter name = booking_tool to get every booking-tool promotion.
 * 
 * When to trigger this event:
 * 1. Journal - Support

promotion_name and id:
delivery-time-cost_support
returns-refunds_support
secure-payments_support
custommade-customizing_app
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/dmF0VfnHj
 * 2. Footer - Newsletter

promotion_id & name:
newsletter_campaign

Creative:
footer_link
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/9dwfTm8_b
 * 3. Lookbuilder - Shop the look

promotion id + name:
lookbuilder_app

creative: 
shop-the-look_panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/Do1oLQCdp
 * 4. Lookbuilder - wishlist

Promotion id + name:
lookbuilder_app

Creative:
panel_wishlist
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/XvOaPaSL_
 * 5. Lookbuilder - minicart

Promotion id + name:
lookbuilder_app

Creative:
panel_minicart
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/81fjlwsyo
 * 6. Lookbuilder - MWTW

Promotion id + name:
lookbuilder_app

Creative:
pdp_panel_mwtw
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/udZGnmpX6
 * 7. ﻿Lookbuilder - summary screen

Promotion id + name:
lookbuilder_app

Creative:
lookbuilder_summary
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/uqdx_UxpT
 * 8. promotion_id: store-page-stores
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/9dXcuobIKLOwwgs-1tXc0
 * 9. promotion_id: store-page-store-locator
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/hQW24lFqN92yLPF8-6p71
 * 10. Booking-tool links (storefront and custom-made) that open the booking tool. promotion_id values: booking_tool_store_card, booking_tool_store_list, booking_tool_services_cta, booking_tool_services_item, booking_tool_style_expert, booking_tool_store_faq, booking_tool_journal_faq, booking_tool_expert_panel, booking_tool_cms_link, booking_tool_cm_finish_in_store, booking_tool_cm_size_passport
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k/trigger/be1sOWk47G1CTJq_T0O88
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 
 * For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.creative: Name of location and type of the promotion
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.storeName: Name of the store the button/action belongs to.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k}
 */
export function promotionViewed(properties: PromotionViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  properties.eventLocation !== undefined && properties.eventLocation !== null ?
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
  eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  properties.storeName !== undefined && properties.storeName !== null ?
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: properties.storeName}) :
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: null});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPosition(properties.position));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Xo8CpcqD3k", "35420009b2a25022561fed0a819207a7868349b7a69002fadbac4990138120fc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Promotion Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Xo8CpcqD3k", "Promotion Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Promotion Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Viewed", eventProperties, "Xo8CpcqD3k", "35420009b2a25022561fed0a819207a7868349b7a69002fadbac4990138120fc");
    }
    // destination Segment
    Segment.logEvent("Promotion Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PromotionViewedStorePagesProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string | null | undefined;
  promotionId: string;
  name: string | null | undefined;
  position: number;
  storeName: string | null | undefined;
  locationCode: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
  creative: CreativeValueType;
}
/**
 * Promotion Viewed: When a promotion is being shown in the viewport 
 * Only add the 'products' object, if there are products in the promotion.
 * Links that open the booking tool always send name = booking_tool and promotion_id = booking_tool_<entry point>, where <entry point> is the same value as event_location on book_store_appointment_clicked (e.g. booking_tool_store_card). Filter name = booking_tool to get every booking-tool promotion., event variant
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 
 * For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.storeName: Name of the store the button/action belongs to.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.creative: Name of location and type of the promotion
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/Xo8CpcqD3k.rdHPTDPau9dKhX8xYE-dm}
 */
export function promotionViewedStorePages(properties: PromotionViewedStorePagesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  properties.eventLocation !== undefined && properties.eventLocation !== null ?
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
    eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
  eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  properties.storeName !== undefined && properties.storeName !== null ?
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: properties.storeName}) :
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: null});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPosition(properties.position));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Xo8CpcqD3k.rdHPTDPau9dKhX8xYE-dm", "1c4a1763e03cb788e74d68080a58a0784e943f35745b84ec17c669a43c3053a5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Promotion Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Xo8CpcqD3k.rdHPTDPau9dKhX8xYE-dm", "Promotion Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Promotion Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Viewed", eventProperties, "Xo8CpcqD3k.rdHPTDPau9dKhX8xYE-dm", "1c4a1763e03cb788e74d68080a58a0784e943f35745b84ec17c669a43c3053a5");
    }
    // destination Segment
    Segment.logEvent("Promotion Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PromotionClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  promotionId: string;
  name: string | null | undefined;
  creative: CreativeValueType;
  position: number;
  shopTheLookId: string;
  storeName: string | null | undefined;
  locationCode: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * Promotion Clicked: When a promotion is clicked
 * Only add the 'products' object, if there are products in the promotion.
 * Links that open the booking tool always send name = booking_tool and promotion_id = booking_tool_<entry point>, where <entry point> is the same value as event_location on book_store_appointment_clicked (e.g. booking_tool_store_card). Filter name = booking_tool to get every booking-tool promotion.
 * 
 * When to trigger this event:
 * 1. a user clicks on a store page from the see all stores page

promotion_id: store-page-store-locator
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lb-B8o9Lf/trigger/GzA_Z4Z9D8qEDlmDIPG90
 * 2. a user clicks on a store page from the stores page

promotion_id: store-page-stores
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lb-B8o9Lf/trigger/lqnqi7Ou7QZwpkV5eWW8h
 * 3. Booking-tool links (storefront and custom-made) that open the booking tool. promotion_id values: booking_tool_store_card, booking_tool_store_list, booking_tool_services_cta, booking_tool_services_item, booking_tool_style_expert, booking_tool_store_faq, booking_tool_journal_faq, booking_tool_expert_panel, booking_tool_cms_link, booking_tool_cm_finish_in_store, booking_tool_cm_size_passport
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lb-B8o9Lf/trigger/nnHt-_zsTHE0EZi7v6rJl
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 
 * For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.creative: Name of location and type of the promotion
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.storeName: Name of the store the button/action belongs to.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lb-B8o9Lf}
 */
export function promotionClicked(properties: PromotionClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
  properties.storeName !== undefined && properties.storeName !== null ?
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: properties.storeName}) :
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: null});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPosition(properties.position));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lb-B8o9Lf", "4a80f5c880dd00a8ff1922dad418444ed6b9911857174bc87c408b18aead64ad", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Promotion Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lb-B8o9Lf", "Promotion Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Promotion Clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Clicked", eventProperties, "lb-B8o9Lf", "4a80f5c880dd00a8ff1922dad418444ed6b9911857174bc87c408b18aead64ad");
    }
    // destination Segment
    Segment.logEvent("Promotion Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PromotionClickedStorePagesProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  promotionId: string;
  name: string | null | undefined;
  position: number;
  storeName: string | null | undefined;
  locationCode: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
  creative: CreativeValueType;
}
/**
 * Promotion Clicked: When a promotion is clicked
 * Only add the 'products' object, if there are products in the promotion.
 * Links that open the booking tool always send name = booking_tool and promotion_id = booking_tool_<entry point>, where <entry point> is the same value as event_location on book_store_appointment_clicked (e.g. booking_tool_store_card). Filter name = booking_tool to get every booking-tool promotion., event variant
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 
 * For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
 * Will be gift card for giftcard
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * ---- 
 * For Promotion Viewed and Promotion Clicked on Store pages
 * Name: store_slider|store_slider_filtered|store_list_overview
 * ID: Store ID
 * ---- 
 * For booking_tool_step_viewed / booking_tool_step_completed: step name matching the step number — 1 store-locator, 2 employees-list, 3 timeslots, 4 user-data, 5 confirmation, 6 pre-appointment-purpose.
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.storeName: Name of the store the button/action belongs to.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.creative: Name of location and type of the promotion
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lb-B8o9Lf.lW_iEKT71i3tGJhWc8rvy}
 */
export function promotionClickedStorePages(properties: PromotionClickedStorePagesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: null});
  eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
  properties.storeName !== undefined && properties.storeName !== null ?
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: properties.storeName}) :
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: null});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPosition(properties.position));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lb-B8o9Lf.lW_iEKT71i3tGJhWc8rvy", "d36011196ce0b94693a3cacd5004de6db2d078c07b101b275d2432f42cdce1f1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Promotion Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lb-B8o9Lf.lW_iEKT71i3tGJhWc8rvy", "Promotion Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Promotion Clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Clicked", eventProperties, "lb-B8o9Lf.lW_iEKT71i3tGJhWc8rvy", "d36011196ce0b94693a3cacd5004de6db2d078c07b101b275d2432f42cdce1f1");
    }
    // destination Segment
    Segment.logEvent("Promotion Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface StyleOptionSelectProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  btcOption: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * style_option_select: Firing when the style option is selected.
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/eRtiLrwzB}
 */
export function styleOptionSelect(properties: StyleOptionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.btcOption !== undefined && properties.btcOption !== null ?
    eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption}) :
    eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eRtiLrwzB", "f12a6109e48d42521c9614eeb6198b88b04da92fec0e0e0c14bc30d0e67bb997", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("style_option_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eRtiLrwzB", "style_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_select", eventProperties, "eRtiLrwzB", "f12a6109e48d42521c9614eeb6198b88b04da92fec0e0e0c14bc30d0e67bb997");
    }
    // destination Segment
    Segment.logEvent("style_option_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ShowAdvancedOptionsProperties {
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * show_advanced_options: When clicking on 'Advanced options' 
 * - event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When "Advanced options" clicked
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/By2FfLdNT/trigger/w2gRDED_Zf_SiqetVi_Fx
 * 
 * @param properties the properties associated with this event
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/By2FfLdNT}
 */
export function showAdvancedOptions(properties: ShowAdvancedOptionsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "By2FfLdNT", "adf70e54ddbb20f5be2be59f14d74f5962c74a247a7844977275811dfade7dff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("show_advanced_options", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("By2FfLdNT", "show_advanced_options", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("show_advanced_options", eventProperties, "By2FfLdNT", "adf70e54ddbb20f5be2be59f14d74f5962c74a247a7844977275811dfade7dff");
    }
    // destination Segment
    Segment.logEvent("show_advanced_options", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ShowAdvancedOptionsSpProperties {
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * show_advanced_options: When clicking on 'Advanced options' 
 * - event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket, variant description: event_category: sp_interactions
 * event_location: sp_{{category}}_{{subcategory}} or sp_{{subcategory}}
 * 
 * @param properties the properties associated with this event
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/By2FfLdNT.647KbMonc}
 */
export function showAdvancedOptionsSp(properties: ShowAdvancedOptionsSpProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "By2FfLdNT.647KbMonc", "096ce4a350763bc5fcf421cf48b7114966992efe256de29c6deef57300060642", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("show_advanced_options", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("By2FfLdNT.647KbMonc", "show_advanced_options", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("show_advanced_options", eventProperties, "By2FfLdNT.647KbMonc", "096ce4a350763bc5fcf421cf48b7114966992efe256de29c6deef57300060642");
    }
    // destination Segment
    Segment.logEvent("show_advanced_options", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdvancedSectionSelectProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  cmItemValue: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * advanced_section_select: Firing when the advanced style option is selected.
 * - cm_option: {{clicked option}} example: shoulder|pockets|amf
 * - event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on an advanced section
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/PM2yXCSNi/trigger/UQJNOV2IK
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/PM2yXCSNi}
 */
export function advancedSectionSelect(properties: AdvancedSectionSelectProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PM2yXCSNi", "dd890644ba865e145f6fa29472dcc0fceb04ef1b1499263a80c8c3a3269e2492", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("advanced_section_select", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PM2yXCSNi", "advanced_section_select", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("advanced_section_select", eventProperties, "PM2yXCSNi", "dd890644ba865e145f6fa29472dcc0fceb04ef1b1499263a80c8c3a3269e2492");
    }
    // destination Segment
    Segment.logEvent("advanced_section_select", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdvancedOptionConfirmProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  cmItemValue: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * advanced_option_confirm: Firing when the advanced option is confirmed.
 * - cm_option: {{section}}_{{subsection}}_{{clicked option}} example: lining_type_half-lined|lining_color_paisley-purple|buttons_button_dark-brown| buttons_sleeve_5-kissing-buttons
 * - event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When confirming an advanced option
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/knCkEc_gS/trigger/YHIZ-tjRx
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/knCkEc_gS}
 */
export function advancedOptionConfirm(properties: AdvancedOptionConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "knCkEc_gS", "c40e853497af08e6d11ee59c20865d13db51e2ad308ef74877363f35dad802c2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("advanced_option_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("knCkEc_gS", "advanced_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("advanced_option_confirm", eventProperties, "knCkEc_gS", "c40e853497af08e6d11ee59c20865d13db51e2ad308ef74877363f35dad802c2");
    }
    // destination Segment
    Segment.logEvent("advanced_option_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummarySeeMinusallMinusdetailsProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string | null | undefined;
  cmItemType: CmItemTypeValueType;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * summary_see-all-details: When clicking on 'See all details' icon on the summary screen 
 * "configurator_type": "suit",
 * "configurator_section": "summary",
 * "current_base_style": "havana|slim_leg_single_pleat|, - can be empty (e.g. for waistcoat) 
 * cm_item_type": "product|fabric"
 * "cm_item_value": "jacket|trousers|waistcoat|fabric",
 * 
 * When to trigger this event:
 * 1. When clicking on the 'See all details' button on the Summary page for a product (jacket, trousers, waistcoat or extra trousers)

"configurator_type": "suit",
"configurator_section": "summary",
"current_base_style": "havana|slim_leg_single_pleat|, - can be empty (e.g. for waistcoat) 
cm_item_type": "product"
"cm_item_value": "jacket|trousers|waistcoat",

Old property "cm_option" -> "cm_item_value"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/v4Qx9DLbW/trigger/rDxOatk1m
 * 2. When clicking on the 'See all details' button on the Summary page for fabric

"configurator_type": "suit",
"configurator_section": "summary",
cm_item_type": "fabric"
"cm_item_value": "fabric",

Old property "cm_option" -> "cm_item_value"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/v4Qx9DLbW/trigger/W0uZXvvwZjpuA_pTHA09P
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/v4Qx9DLbW}
 */
export function summarySeeAllDetails(properties: SummarySeeMinusallMinusdetailsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "v4Qx9DLbW", "b313d96b596f437a373788c67b87e4080fadf4bd2d0ef672f7bb66d59dfa54f8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_see-all-details", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("v4Qx9DLbW", "summary_see-all-details", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_see-all-details", eventProperties, "v4Qx9DLbW", "b313d96b596f437a373788c67b87e4080fadf4bd2d0ef672f7bb66d59dfa54f8");
    }
    // destination Segment
    Segment.logEvent("summary_see-all-details", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryFinishMinusinMinusstoreProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  saveMethod: SaveMethodValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * summary_finish-in-store: When clicking on 'Finish in store' button on the summary screen 
 * Properties:
 * "save_method": "save_for_later|finish_in_store" 
 *  "configurator_type": "suit|shirt"...,
 * 
 * When to trigger this event:
 * 1. When clicking on the 'Finish in store' button on the summary page

"save_method": "finish_in_store" 
 "configurator_type": "suit",
 "configurator_section": "summary",
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/w6DzGePbE/trigger/D-14YS-IO
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.saveMethod: Shows if the user is saving configuration to their email via Save for later (bookmark) or Finish in store flows.
 * When the user is clicking on Bookmark button un summary page  - 'save_method': 'save_for_later'
 * When the user clicks on 'Walk in anytime'option in Finish in store panel - 'save_method': 'finish_in_store'
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/w6DzGePbE}
 */
export function summaryFinishInStore(properties: SummaryFinishMinusinMinusstoreProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "f3ajBguu21s6g5irQgmVk", name: "save_method", value: properties.saveMethod});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "w6DzGePbE", "a949bef16620e3a90f6a345ee9ff2765a88ff2577a762d44041e1e2c364e18bb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_finish-in-store", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("w6DzGePbE", "summary_finish-in-store", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_finish-in-store", eventProperties, "w6DzGePbE", "a949bef16620e3a90f6a345ee9ff2765a88ff2577a762d44041e1e2c364e18bb");
    }
    // destination Segment
    Segment.logEvent("summary_finish-in-store", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummarySaveMinusandMinusshareProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  saveMethod: SaveMethodValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * summary_save-and-share: When clicking on 'Save and Share' button on the summary screen 
 * Properties:
 * "save_method": "save_for_later|finish_in_store" 
 *  "configurator_type": "suit|trousers|shirt",
 * 
 * When to trigger this event:
 * 1. When clicking on 'Save and Share' button on the summary screen 
 "save_method": "save_for_later"
 "configurator_type": "suit",
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KZNxeK-An/trigger/uxKyd_op-
 * 2. When the user selects 'Walk in anytime" option in finish in store side panel
"save_method": "finish_in_store"
 "configurator_type": "suit",
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KZNxeK-An/trigger/huFeTUd2aBY62a77AnpNo
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.saveMethod: Shows if the user is saving configuration to their email via Save for later (bookmark) or Finish in store flows.
 * When the user is clicking on Bookmark button un summary page  - 'save_method': 'save_for_later'
 * When the user clicks on 'Walk in anytime'option in Finish in store panel - 'save_method': 'finish_in_store'
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KZNxeK-An}
 */
export function summarySaveAndShare(properties: SummarySaveMinusandMinusshareProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "f3ajBguu21s6g5irQgmVk", name: "save_method", value: properties.saveMethod});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KZNxeK-An", "bba040dcce00054150d42089dd11d4fc532703542fee08ef1c22bc3f8b390572", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_save-and-share", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KZNxeK-An", "summary_save-and-share", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_save-and-share", eventProperties, "KZNxeK-An", "bba040dcce00054150d42089dd11d4fc532703542fee08ef1c22bc3f8b390572");
    }
    // destination Segment
    Segment.logEvent("summary_save-and-share", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SummaryEditProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string | null | undefined;
  cmItemType: CmItemTypeValueType;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * summary_edit: When clicking on 'edit' icon on the summary screen for a product or separate option 
 * Properties
 * "configurator_type": "suit",
 * "configurator_section": "summary",
 * "current_base_style": "havana|slim_leg_single_pleat|, - can be empty (e.g. for waistcoat) 
 * cm_item_type": "product|basic_option|advanced_option"
 * "cm_item_value": "jacket|trousers|waistcoat|extra_trousers|lining_half-lined",
 * 
 * When to trigger this event:
 * 1. When clicking on 'edit' icon on the summary screen for a product

Properties
"configurator_type": "suit_jacket",
"configurator_section": "summary",
"current_base_style": "havana|slim_leg_single_pleat|, - can be empty (e.g. for waistcoat)
cm_item_type": "product"
"cm_item_type": "jacket|trousers|waistcoat|extra_trousers",

Old property "cm_option" -> "cm_item_type"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KNnHKBbfV/trigger/-TISpFDBA
 * 2. When user is clicking on one of the options to edit it specific product options on Summary page

Properties
"configurator_type": "suit_jacket",
"configurator_section": "summary",
 "current_base_style": "havana|slim_leg_single_pleat|, - can be empty (e.g. for waistcoat)
cm_item_type": "basic_option"
"cm_item_value": "lining_half-lined",

Old property "cm_option" -> "cm_item_type"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KNnHKBbfV/trigger/1qfjmWvSJTo6K1lERddOa
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KNnHKBbfV}
 */
export function summaryEdit(properties: SummaryEditProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KNnHKBbfV", "83e62e5caa69e892fa99a01911047179687d095d8538d911c8e5ee290fc1f0bc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("summary_edit", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KNnHKBbfV", "summary_edit", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_edit", eventProperties, "KNnHKBbfV", "83e62e5caa69e892fa99a01911047179687d095d8538d911c8e5ee290fc1f0bc");
    }
    // destination Segment
    Segment.logEvent("summary_edit", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricFilterSelectedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string | null | undefined;
  cmItemType: CmItemTypeValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * fabric_filter_selected: When clicking on specific filter options in the Filter panel on the fabric section
 * cm_item_type: "filter" - always for this event
 * cm_item_value: {{selection option}}_{{selected choice}} example: color_blue|all-fabrics_season_fall-winter -> for filter selections
 * 
 * When to trigger this event:
 * 1. When filter (or sorting) option is clicked.
e.g. cm_item_value=“sort_by_newest”
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/li0ZEZ5ir/trigger/Zl0NvCbc4AjDK3h_cHUxb
 * 2. When filter selection is made in Filter panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/li0ZEZ5ir/trigger/vEh-9ebe-xxiw4Dk0EgRB
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/li0ZEZ5ir}
 */
export function fabricFilterSelected(properties: FabricFilterSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "li0ZEZ5ir", "542d7467992b5df5b52fd970e75aeca410b6dd39cdcffbda737e8334431257aa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_filter_selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("li0ZEZ5ir", "fabric_filter_selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_filter_selected", eventProperties, "li0ZEZ5ir", "542d7467992b5df5b52fd970e75aeca410b6dd39cdcffbda737e8334431257aa");
    }
    // destination Segment
    Segment.logEvent("fabric_filter_selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricInformationProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string;
  cmSelectedView: CmSelectedViewValueType | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * fabric_information: When clicking on the 'information' icon on the fabric section
 * - cm_option: {{selected fabric group }}
 * 
 * When to trigger this event:
 * 1. When clicking on the 'information' icon on the fabric section
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tehuWAxI2/trigger/__l2YufBO
 * 2. When the user clicks on fabric info icon (after icon redesign)
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tehuWAxI2/trigger/m9plDmxqlK3Ue8E2LP5q8
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmSelectedView: Value showing in which view the action is made (Applicable for events on Fabric section, null in other cases)
 * “cm_view“: |model_view|product_view|
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tehuWAxI2}
 */
export function fabricInformation(properties: FabricInformationProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue});
  properties.cmSelectedView !== undefined && properties.cmSelectedView !== null ?
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: properties.cmSelectedView}) :
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tehuWAxI2", "246a9834b4ce32fdb3114154d9a5ed7adf4587d91cedfb6bc7335ec346d699dc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_information", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tehuWAxI2", "fabric_information", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_information", eventProperties, "tehuWAxI2", "246a9834b4ce32fdb3114154d9a5ed7adf4587d91cedfb6bc7335ec346d699dc");
    }
    // destination Segment
    Segment.logEvent("fabric_information", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustommadeFinishedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * custommade_finished: Firing when the 'done' button is clicked.
 * Event is renamed from custommade_done to custommade_finished to match current UI
 * 
 * When to trigger this event:
 * 1. When clicking on the 'Finished' button in the interface
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/ribVSDo30/trigger/h-CHpb7QX
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/ribVSDo30}
 */
export function custommadeFinished(properties: CustommadeFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ribVSDo30", "bb73e65847907b84736157d3ecff051f417455729d3f45c86ad0795a56377d78", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custommade_finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ribVSDo30", "custommade_finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custommade_finished", eventProperties, "ribVSDo30", "bb73e65847907b84736157d3ecff051f417455729d3f45c86ad0795a56377d78");
    }
    // destination Segment
    Segment.logEvent("custommade_finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeDesigningStartedProperties {
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * custom_made_designing_started: Firing when the 'done' button is clicked.
 * - event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * - cm_option: overlay_intro|overlay_fabric|overlay_style|overlay_personalise|overlay_fit
 * 
 * When to trigger this event:
 * 1. When clicking on the 'Start designing' button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/GyG7nyMfK/trigger/V4U57Xhsol
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/GyG7nyMfK}
 */
export function customMadeDesigningStarted(properties: CustomMadeDesigningStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "cm_interactions"});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GyG7nyMfK", "be97e17b49bea478e4fe37486a18cc3343056653c1b9133d128f824764b707b5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_designing_started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GyG7nyMfK", "custom_made_designing_started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_designing_started", eventProperties, "GyG7nyMfK", "be97e17b49bea478e4fe37486a18cc3343056653c1b9133d128f824764b707b5");
    }
    // destination Segment
    Segment.logEvent("custom_made_designing_started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeOverlayExitedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  overlayStep: OverlayStepValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * custom_made_overlay_exited: Firing when clicking outside the overlay to close it, without clicking on the 'start designing' button 
 * overlay_step": "fabric|fit|intro|style|personalize", - currently visible step
 * "configurator_type": "suit -jacket|trousers",
 * "configurator_section": "fabric|style|basic_options|summary",
 * 
 * When to trigger this event:
 * 1. When clicking outside the overlays to close it.

Remove old events: 

overlay_fabric_showed
overlay_fit_showed
overlay_intro_showed
overlay_style_showed
overlay_personalise_showed
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/gE13pyuKe/trigger/4UITVsKUey
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.overlayStep: Specifies which step of the overlay is shown to the user
 * overlay_step = fabric|fit|Intro|style|personalize
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/gE13pyuKe}
 */
export function customMadeOverlayExited(properties: CustomMadeOverlayExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "1quiHy5MgQFaaz0ja_zil", name: "overlay_step", value: properties.overlayStep});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gE13pyuKe", "a5cdbaff3f8efb7c1cd29e7c74588b60b9133dc2072f6d4d579488c1fcb7b8fe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_overlay_exited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gE13pyuKe", "custom_made_overlay_exited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_overlay_exited", eventProperties, "gE13pyuKe", "a5cdbaff3f8efb7c1cd29e7c74588b60b9133dc2072f6d4d579488c1fcb7b8fe");
    }
    // destination Segment
    Segment.logEvent("custom_made_overlay_exited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SizePassportLoginClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  flowId: string | null | undefined;
  productId: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * size_passport_login_clicked: This event represents when a user clicks on the login button on the passport custom sizes panel.
 * 
 * When to trigger this event:
 * 1. When the user clicks in the Log In button on the select you size
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/7OFmS9lkNdiiAKVrEzmHa/trigger/yD_9OxG6xRSB_I2_HcUzl
 * 2. When the user clicks in the "Log In" on the Size Passport
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/7OFmS9lkNdiiAKVrEzmHa/trigger/-wfKyyNVH2jyUFF820YmZ
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.flowId: UUID created once when a flow opens: the booking tool, or the CM Lite panel on the PDP ('Select size and fit'). Groups all events of one flow.
 * @param properties.productId: SKU of product
 * for custommade:
 * trousers: dyo-trousers
 * jacket: dyo-jacket
 * waistcoat: dyo-waistcoat
 * coat: dyo-coat
 * shirt: dyo-shirt
 * For CML: RTW code of currently selected product or 'CM-TROUSERS' for CM items
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/7OFmS9lkNdiiAKVrEzmHa}
 */
export function sizePassportLoginClicked(properties: SizePassportLoginClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.flowId !== undefined && properties.flowId !== null ?
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: properties.flowId}) :
    eventPropertiesArray.push({id: "1RBu-9OEAnlhmxhtHSqPQ", name: "flow_id", value: null});
  eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7OFmS9lkNdiiAKVrEzmHa", "14474ff73bb254a0bfda976b8d24c2c28dddcff49bcc16ec3bb1c9db10763ce6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("size_passport_login_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7OFmS9lkNdiiAKVrEzmHa", "size_passport_login_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_passport_login_clicked", eventProperties, "7OFmS9lkNdiiAKVrEzmHa", "14474ff73bb254a0bfda976b8d24c2c28dddcff49bcc16ec3bb1c9db10763ce6");
    }
    // destination Segment
    Segment.logEvent("size_passport_login_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * search_clicked: This event represents the action of clicking the search icon to initiate a search on the website
 * 
 * When to trigger this event:
 * 1. When the user clicks in the Search button. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tJdEwNjByERhlix662YbL/trigger/PuHYswmL1GCfyuvBa-Fhn
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tJdEwNjByERhlix662YbL}
 */
export function searchClicked(properties: SearchClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tJdEwNjByERhlix662YbL", "f734522000b57cb41c0ef80ddf8525092a61bbe87d51c23679101295e7d9b217", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("search_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tJdEwNjByERhlix662YbL", "search_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_clicked", eventProperties, "tJdEwNjByERhlix662YbL", "f734522000b57cb41c0ef80ddf8525092a61bbe87d51c23679101295e7d9b217");
    }
    // destination Segment
    Segment.logEvent("search_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchClickedCustomMadeProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * search_clicked: This event represents the action of clicking the search icon to initiate a search on the website, variant description: This event represents when a user clicks in the Search to search for an option in the custom made tool
 * 
 * When to trigger this event:
 * 1. When the user clicks in the Search button on custom made tool
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW/trigger/iijYELtg_Y2ORJLUVujKR
 * 2. Trigger searchClickedCustomMade event when the Search button is clicked on Fabric section (after removing Fabric Groups section)
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW/trigger/Kl0ibdSzfTo9hUTBzuj4g
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW}
 */
export function searchClickedCustomMade(properties: SearchClickedCustomMadeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "70233f4d6a21274b312503a7fec0f3abd7cc34749cc3b5a93db6a987783d56d2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("search_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "search_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_clicked", eventProperties, "tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "70233f4d6a21274b312503a7fec0f3abd7cc34749cc3b5a93db6a987783d56d2");
    }
    // destination Segment
    Segment.logEvent("search_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeCategoryChangedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  previousCategory: PreviousCategoryValueType;
  selectedCategory: SelectedCategoryValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * custom_made_category_changed: This event represents when a user clicks in a different category in the Custom Made tool
 * previous_category, - name of category where the user is currently
 * selected_category - name of category where the user is clicking to
 * e.g. "selected_category": "fabric|jacket|trousers|waistcoat|summary"
 * 
 * When to trigger this event:
 * 1. When the user clicks in a category

Properties:
"configurator_type": "suit",
"configurator_section": "jacket_options", 
"current_category": "jacket", - name of category where the user is currently
"selected_category": "trousers" - name of category where the user is clicking to
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/aiE2qvtr1j5gDEjP0wLIn/trigger/j4ecsWd0b3KWRcaEtD4LQ
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.previousCategory: Shows the category in configurator the user is currently on:
 * “current category”= 'fabric|jacket|trousers|waistcoat|summary'
 * @param properties.selectedCategory: Shows the selected category in configurator clicked on by the user:
 * “selected_category”= 'fabric|jacket|trousers|waistcoat|summary'
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/aiE2qvtr1j5gDEjP0wLIn}
 */
export function customMadeCategoryChanged(properties: CustomMadeCategoryChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "yTYaObFcbitSDmR-P2yYb", name: "previous_category", value: properties.previousCategory});
  eventPropertiesArray.push({id: "hi1tNi_eFLTccvmC0wrZw", name: "selected_category", value: properties.selectedCategory});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aiE2qvtr1j5gDEjP0wLIn", "275ec27b381857765d72b704abb9c6248b4c42584ad083a009e9c7301604d549", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_category_changed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aiE2qvtr1j5gDEjP0wLIn", "custom_made_category_changed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_category_changed", eventProperties, "aiE2qvtr1j5gDEjP0wLIn", "275ec27b381857765d72b704abb9c6248b4c42584ad083a009e9c7301604d549");
    }
    // destination Segment
    Segment.logEvent("custom_made_category_changed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EditSizePassportClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * edit_size_passport_clicked: This event represents when the user clicks to edit the Size Passport
 * 
 * When to trigger this event:
 * 1. When the user clicks to edit the Size Passport
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/qY0FT_xmPZPgEdEX48HhP/trigger/ybrT9aakCZFUYNBuYs8jg
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/qY0FT_xmPZPgEdEX48HhP}
 */
export function editSizePassportClicked(properties: EditSizePassportClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qY0FT_xmPZPgEdEX48HhP", "5c6ba3a8c80943bb519185cd026bce4e2a4f3349c4af4cb230367f011d7565f1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("edit_size_passport_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qY0FT_xmPZPgEdEX48HhP", "edit_size_passport_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("edit_size_passport_clicked", eventProperties, "qY0FT_xmPZPgEdEX48HhP", "5c6ba3a8c80943bb519185cd026bce4e2a4f3349c4af4cb230367f011d7565f1");
    }
    // destination Segment
    Segment.logEvent("edit_size_passport_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SizePassportSizeGuideClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * size_passport_size_guide_clicked: This event represents when a user clicks in the "Size guide" button on the "Select your size" panel
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Size guide" in the size passport tool
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/B0-4lwxAHnmpLXm3gerwz/trigger/8xkdqj5c6CWuZJD7P2-TZ
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/B0-4lwxAHnmpLXm3gerwz}
 */
export function sizePassportSizeGuideClicked(properties: SizePassportSizeGuideClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "B0-4lwxAHnmpLXm3gerwz", "3024e0645a2de3c463942ae4e0c326de95098a1701387c2190ff88d4e0621da9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("size_passport_size_guide_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("B0-4lwxAHnmpLXm3gerwz", "size_passport_size_guide_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_passport_size_guide_clicked", eventProperties, "B0-4lwxAHnmpLXm3gerwz", "3024e0645a2de3c463942ae4e0c326de95098a1701387c2190ff88d4e0621da9");
    }
    // destination Segment
    Segment.logEvent("size_passport_size_guide_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeDesignSharedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  saveMethod: SaveMethodValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * custom_made_design_shared: This event represents when the user clicks in "Send" to share a new custom made design
 * "save_method": "save_for_later|finish_in_store" - depending if the user clicked on bookmark or Finish in store before
 *  "configurator_type": "suit|shirt"...,
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Send" in the "Save your design" page

Properties:
"save_method": "save_for_later|finish_in_store" - depending if the user clicked on bookmark or Finish in store before
 "configurator_type": "suit",
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/0dqD99m2Wb2StM-xUOPK0/trigger/EhL9Ld9g1JVopzuT0Por4
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.saveMethod: Shows if the user is saving configuration to their email via Save for later (bookmark) or Finish in store flows.
 * When the user is clicking on Bookmark button un summary page  - 'save_method': 'save_for_later'
 * When the user clicks on 'Walk in anytime'option in Finish in store panel - 'save_method': 'finish_in_store'
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/0dqD99m2Wb2StM-xUOPK0}
 */
export function customMadeDesignShared(properties: CustomMadeDesignSharedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "f3ajBguu21s6g5irQgmVk", name: "save_method", value: properties.saveMethod});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0dqD99m2Wb2StM-xUOPK0", "2cb082ec095eac620fae4f937fb61d2945e78408e4341ef139b28487a004f361", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_design_shared", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0dqD99m2Wb2StM-xUOPK0", "custom_made_design_shared", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_design_shared", eventProperties, "0dqD99m2Wb2StM-xUOPK0", "2cb082ec095eac620fae4f937fb61d2945e78408e4341ef139b28487a004f361");
    }
    // destination Segment
    Segment.logEvent("custom_made_design_shared", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BookStoreAppointmentClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  position: number | null | undefined;
  storeName: string | null | undefined;
  locationCode: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * book_store_appointment_clicked: Fired by the host when the user clicks any button that opens the booking tool. dbt links it to the next booking_tool_opened in the session to find the entry point.
 * Originally: this event represents when the user clicks in "Book appointment" to finish the custom made design in store (kept for custom-made compatibility).
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Book appointment" to finish the custom made design in store
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/XpZ6ARx_tSEDsYxHDRdPb/trigger/ipePJ-6xM7ZwC0KS-jAPq
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.position: Position of product, should always start with 1.
 * Shop by look slider: This should represent which position in the slider.
 * @param properties.storeName: Name of the store the button/action belongs to.
 * @param properties.locationCode: Location code of the store the booking is for, e.g. SR-US-Atlanta-Lenox. Same value as dim__location.location_code. Empty until the user has a store (for example before choosing one on the store locator step).
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/XpZ6ARx_tSEDsYxHDRdPb}
 */
export function bookStoreAppointmentClicked(properties: BookStoreAppointmentClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.position !== undefined && properties.position !== null ?
    eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position}) :
    eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: null});
  properties.storeName !== undefined && properties.storeName !== null ?
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: properties.storeName}) :
    eventPropertiesArray.push({id: "B2n1lx05qeQKhSnnzzfR8", name: "store_name", value: null});
  properties.locationCode !== undefined && properties.locationCode !== null ?
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: properties.locationCode}) :
    eventPropertiesArray.push({id: "VwcTk1WXIwBgAVvbFk4uC", name: "location_code", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPositionOptional(properties.position));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XpZ6ARx_tSEDsYxHDRdPb", "22acb0714aef3a4cbb4ed91bd92e855dfd3765337be5facb713eb94b88437984", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("book_store_appointment_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XpZ6ARx_tSEDsYxHDRdPb", "book_store_appointment_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'book_store_appointment_clicked': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("book_store_appointment_clicked", eventProperties, "XpZ6ARx_tSEDsYxHDRdPb", "22acb0714aef3a4cbb4ed91bd92e855dfd3765337be5facb713eb94b88437984");
    }
    // destination Segment
    Segment.logEvent("book_store_appointment_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmCustomizationAddedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemType: CmItemTypeValueType;
  cmItemValue: string | null | undefined;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_customization_added: "cm_item_type": "fabric|product|base_style|option_group|option|option_group_advanced"
 * "configurator_section": "summary|Waistcoat|
 * 
 * When to trigger this event:
 * 1. When Waistcoat is added in configurator
Old names for properties -> new names: value

"cm_option_type" ->"cm_item_type": "product"
 "cm_option"->"cm_item_value": "Waistcoat"
 "configurator_section": "waistcoat"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lxK5vsRyBGDPHDXjXUTtB/trigger/MXkPbgmBjJVe95EveaVFr
 * 2. When Waistcoat is added on Summary page
Old names for properties -> new names: value

"cm_option_type"->"cm_item_type": "product"
 "cm_option"-> ""cm_item_value"": "Waistcoat"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lxK5vsRyBGDPHDXjXUTtB/trigger/DVPcOAmp2CeHIWNr4V4YW
 * 3. When Extra trousers are added on Summary page
Old names for properties -> new names: value

"cm_option_type"-> "cm_item_type":"product"
 "cm_option"-> "cm_item_value": "ExtraTrousers"
"configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lxK5vsRyBGDPHDXjXUTtB/trigger/CxvyZ6lnQlAeMd7CukEl2
 * 4. Monogram applied after selection all monogram settings

"configurator_section": "jacket_options"
"selected_base_style": "havana"
"cm_item_type": "option"
 "cm_item_value": "monogram_inside-jacket"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lxK5vsRyBGDPHDXjXUTtB/trigger/rVWJL0FJ-toA28DFcFFIP
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/lxK5vsRyBGDPHDXjXUTtB}
 */
export function cmCustomizationAdded(properties: CmCustomizationAddedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lxK5vsRyBGDPHDXjXUTtB", "c0fa84fb362e7be61da47459cf5b125cd690d6f394255c6eec0acf84d67a2f83", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_customization_added", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lxK5vsRyBGDPHDXjXUTtB", "cm_customization_added", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_customization_added", eventProperties, "lxK5vsRyBGDPHDXjXUTtB", "c0fa84fb362e7be61da47459cf5b125cd690d6f394255c6eec0acf84d67a2f83");
    }
    // destination Segment
    Segment.logEvent("cm_customization_added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmCustomizationDeleteInitiatedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemType: CmItemTypeValueType;
  cmItemValue: string;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_customization_delete_initiated: When option or product is deleted 
 * 
 * When to trigger this event:
 * 1. Extra trousers are deleted from Summary page:
Old 
properties:
"cm_option_type": "product"
"cm_option": "ExtraTrouser"
 "configurator_section": "summary"

New properties:
"cm_item_type": "product"
"cm_item_value": "ExtraTrouser"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/RfP0-o-6j9EH6QUl0SDrc/trigger/DTX4Wz4uo8zD2OD2u1qM1
 * 2. When Waistcoat is removed on Summary page
Old 
properties:
"cm_option_type": "product"
"cm_option": "Waistcoat"
 "configurator_section": "summary"

ew properties:
"cm_item_type": "product"
"cm_item_value": "Waistcoat"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/RfP0-o-6j9EH6QUl0SDrc/trigger/40Eo47mUo9gu4gI5WgACH
 * 3. When the option to delete the monogram is clicked 

Properties:
"configurator_type": "jacket",
 "configurator_section": "jacket_options",
 "cm_item_type": "basic_option",
 "current_base_style": "havana"
 "cm_item_value": "monogram_inside-jacket",


Remove monogram_delete event
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/RfP0-o-6j9EH6QUl0SDrc/trigger/sGxIDwstCMNNDZPybXoKm
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/RfP0-o-6j9EH6QUl0SDrc}
 */
export function cmCustomizationDeleteInitiated(properties: CmCustomizationDeleteInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RfP0-o-6j9EH6QUl0SDrc", "3c73002fbc210324854918cc219c91bd0a54056e00558d189eedbfeb166a4588", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_customization_delete_initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RfP0-o-6j9EH6QUl0SDrc", "cm_customization_delete_initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_customization_delete_initiated", eventProperties, "RfP0-o-6j9EH6QUl0SDrc", "3c73002fbc210324854918cc219c91bd0a54056e00558d189eedbfeb166a4588");
    }
    // destination Segment
    Segment.logEvent("cm_customization_delete_initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmCustomizationDeleteConfirmedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string;
  cmItemType: CmItemTypeValueType;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_customization_delete_confirmed: When deletion of a product or an option is confirmed by user
 * 
 * When to trigger this event:
 * 1. User clicks 'Delete" button on Delete Extra trousers modal from Summary page:
Old properties:
"cm_option_type": "product"
"cm_option": "ExtraTrouser"
 "configurator_section": "summary"

New properties: 
"cm_item_type": "product"
"cm_item_value": "ExtraTrouser"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HKitxwiVTzoVlubL7U_jV/trigger/9chbUwgyEN9tjzf-_1kKK
 * 2. User clicks 'Delete" button on Delete Waistcoat modal from Summary page:
Old properties:
"cm_option_type": "product"
"cm_option": "Waistcoat"
 "configurator_section": "summary"

New properties:
"cm_item_type": "product"
"cm_item_value": "Waistcoat"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HKitxwiVTzoVlubL7U_jV/trigger/E876hPPwyzuW7a_3ZfUg9
 * 3. Waistcoat is removed from Waistcoat section:
Old properties:
"cm_option_type": "product"
 "cm_option": "Waistcoat"
 "configurator_section": "waistcoat"

New properties:
"cm_item_type": "product"
"cm_item_value": "Waistcoat"
 "configurator_section": "waistcoat"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HKitxwiVTzoVlubL7U_jV/trigger/rHGm85V2KKfikGmjfQXVJ
 * 4. 
When  removing monogram is confirmed

Properties:
"configurator_type": "jacket",
 "configurator_section": "jacket_options",
 "option_type": "option",
 "current_base_style": "havana"
 "cm_option": "monogram_inside-jacket",
 "page_type": "custommade"

Remove old event monogram_delete_confirm
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HKitxwiVTzoVlubL7U_jV/trigger/aGJbZT2QuaZuNTx3UTTMF
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HKitxwiVTzoVlubL7U_jV}
 */
export function cmCustomizationDeleteConfirmed(properties: CmCustomizationDeleteConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HKitxwiVTzoVlubL7U_jV", "c2ef3bcdeed6be717c8abbd30fff9059564bc4f60bd4e7d17972ecde29708662", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_customization_delete_confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HKitxwiVTzoVlubL7U_jV", "cm_customization_delete_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_customization_delete_confirmed", eventProperties, "HKitxwiVTzoVlubL7U_jV", "c2ef3bcdeed6be717c8abbd30fff9059564bc4f60bd4e7d17972ecde29708662");
    }
    // destination Segment
    Segment.logEvent("cm_customization_delete_confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmCustomizationDeleteCancelledProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string;
  cmItemType: CmItemTypeValueType;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_customization_delete_cancelled: When option or product deletion is canceled by the user
 * 
 * When to trigger this event:
 * 1. When user clicks "Cancel" on Delete Extra trousers modal on Summary page

Old properties:
"cm_option_type": "product"
"cm_option": "ExtraTrousers"
 "configurator_section": "summary"

New Properties:
"cm_item_type": "product"
"cm_item_value": "ExtraTrousers"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/XHKosQeNZBGh1TFUxL_RW/trigger/BoKsL7qVjZM81r992YN4e
 * 2. When user clicks "Cancel" on Delete Waistcoat modal on Summary page

Old properties:
"cm_option_type": "product"
"cm_option": "Waistcoat"
 "configurator_section": "summary"

New Properties:
"cm_item_type": "product"
"cm_item_value": "Waistcoat"
 "configurator_section": "summary"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/XHKosQeNZBGh1TFUxL_RW/trigger/SQzsGX8qyeeFM5BUUwICx
 * 3. When removing monogram is canceled

Properties:
"configurator_type": "jacket",
 "configurator_section": "jacket_options",
 "option_type": "option",
 "current_base_style": "havana"
 "cm_option": "monogram_inside-jacket",
 "page_type": "custommade"


Remove old event monogram_delete_cancel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/XHKosQeNZBGh1TFUxL_RW/trigger/mYxEs0U4NzNWvIFGeu4Ax
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/XHKosQeNZBGh1TFUxL_RW}
 */
export function cmCustomizationDeleteCancelled(properties: CmCustomizationDeleteCancelledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XHKosQeNZBGh1TFUxL_RW", "f91894c279e58690d329d81908a6665c402b2c4d8d42078db586ef288a2e57c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_customization_delete_cancelled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XHKosQeNZBGh1TFUxL_RW", "cm_customization_delete_cancelled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_customization_delete_cancelled", eventProperties, "XHKosQeNZBGh1TFUxL_RW", "f91894c279e58690d329d81908a6665c402b2c4d8d42078db586ef288a2e57c3");
    }
    // destination Segment
    Segment.logEvent("cm_customization_delete_cancelled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmSelectionClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemType: CmItemTypeValueType;
  currentBaseStyle: string | null | undefined;
  cmItemValue: string | null | undefined;
  cmSelectedView: CmSelectedViewValueType | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_selection_clicked: When option or style is selected by user (see triggers):
 * Fabric 
 * Base style
 * Basic option
 * Advanced option
 * Example of main properties depending on the trigger: 
 * "configurator_type": "jacket|suit",
 * "configurator_section": "fabric|jacket_options|trousers_base_style",
 * "current_base_style": "havana|casual", - can be null
 * "cm_item_type": "fabric|base_style|option|option_group|option_group_advanced"
 *  "cm_item_value": "lack_black-wool-stretch|havana|lining|lining_full lined|shoulder",
 * 
 * When to trigger this event:
 * 1. Firing when the fabric option is clicked.
Properties:
"configurator_type": "suit",
"configurator_section": "fabric", - always
"cm_item_type": "fabric" - always
"cm_item_value": "black_black-wool-stretch",
"page_type": "custommade"
"current_base_style" - null


Old event (to remove): fabric_option_select

For fabric: ﻿cm_option: {{clicked fabric group}}_{{clicked color code}} example: most-popular_black-pure-s110s-wool|black_black-wool-stretch 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/n3Pkd8ZyBLQ_n4t-OSPpB/trigger/iKwPXobIKEIr0Er_-fJMt
 * 2. When base style is selected on base style page

Properties:
"configurator_type": "trousers",
"configurator_section": "trousers_base_style",
"current_base_style": "business",
"cm_item_type":"base_style"
 "cm_item_value": "casual",
"page_type": "custommade"

Old event (to remove): style_option_select
 (styleOptionSelectCm)
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/n3Pkd8ZyBLQ_n4t-OSPpB/trigger/M5BKcPBS2AuPJKdZ-qqGR
 * 3. When selecting option value after selecting option

Properties:
"configurator_type": "jacket"
"configurator_section": jacket_options",
"current_base_style": "havana",
"cm_item_type":"option"
 "cm_item_value": "lining_full-lined",
"page_type": "custommade"
 
old parameter cm_option, new parameter's logic is the same: cm_item_value: {{section}}_{{subsection}}_{{clicked option}} example: "button_sleeve_4-kissing-buttons"

Old event (to remove): basic_option_select
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/n3Pkd8ZyBLQ_n4t-OSPpB/trigger/C7Ckqul3TO7cprgFJhnz0
 * 4. When clicking on one of the option groups.

Properties:
"configurator_type": "jacket",
"configurator_section": jacket_options",
"current_base_style": "havana",
"cm_item_type":"option_group"
 "cm_item_value": "lining",
"page_type": "custommade"

Old event (to remove): basic_section_select
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/n3Pkd8ZyBLQ_n4t-OSPpB/trigger/SBGEUkwNLasZGCJ8KzrjN
 * 5. When clicking on one of the advanced option groups


Properties:
"configurator_type": "jacket",
"configurator_section": jacket_options",
"current_base_style": "havana",
"cm_item_type": "option_group_advanced"
 "cm_item_value": "shoulder",
"page_type": "custommade"

Old event (to remove): advanced_section_select
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/n3Pkd8ZyBLQ_n4t-OSPpB/trigger/vQz2mUazXtP74DdmJl2TO
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmSelectedView: Value showing in which view the action is made (Applicable for events on Fabric section, null in other cases)
 * “cm_view“: |model_view|product_view|
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/n3Pkd8ZyBLQ_n4t-OSPpB}
 */
export function cmSelectionClicked(properties: CmSelectionClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  properties.cmSelectedView !== undefined && properties.cmSelectedView !== null ?
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: properties.cmSelectedView}) :
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "n3Pkd8ZyBLQ_n4t-OSPpB", "363735de4be334059b60ce9cbbdf60b3c71737faaca7ec3a3600f7a320d1edb8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_selection_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("n3Pkd8ZyBLQ_n4t-OSPpB", "cm_selection_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_selection_clicked", eventProperties, "n3Pkd8ZyBLQ_n4t-OSPpB", "363735de4be334059b60ce9cbbdf60b3c71737faaca7ec3a3600f7a320d1edb8");
    }
    // destination Segment
    Segment.logEvent("cm_selection_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmEditClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  currentBaseStyle: string | null | undefined;
  cmItemType: CmItemTypeValueType;
  cmItemValue: string;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_edit_clicked: Event when the user initiates change of some customization in configurator, e.g. change style option, monogram, or fabric on summary page
 * Properties:
 * "configurator_type": "jacket|trousers|suit",
 *  "configurator_section": "jacket_options|summary",
 *  "cm_item_type": "fabric|product|option",
 *  "current_base_style": "havana|slim_leg_single_pleat|, - can be empty
 *  "cm_item_value": "monogram_inside-jacket|havana|black_black-wool-stretch",
 * 
 * When to trigger this event:
 * 1. User clicks on Edit button for monogram.
- cm_option_type: "basic_option"

Properties:
"configurator_type": "jacket|suit",
 "configurator_section": "jacket_options",
 "cm_item_type": "option",
 "current_base_style": "havana"
 "cm_item_value": "monogram_inside-jacket",
 "page_type": "custommade"


Old event (to remove): monogram_change
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/r52Jv0tJ1emSvluN5Vgqf/trigger/6F1Ej3jyPA8pgz9o2_233
 * 2. User initiates changing style.

Properties:
"configurator_type": jacket",
 "configurator_section": "jacket_options",
 "cm_item_type": "base_style",
 "selected_base_style": "havana"
 "cm_item_value": "havana",
 "page_type": "custommade"

Old event (to remove): style_option_change
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/r52Jv0tJ1emSvluN5Vgqf/trigger/1VjYxENrJA18NXVrNYcQg
 * 3. User initiates changing fabric on Summary page.

Properties:
"configurator_type": "suit",
 "configurator_section": "summary",
 "cm_item_type": "fabric",
 "cm_item_value": "black_black-wool-stretch",
 "page_type": "custommade"
"current_base_style": null

Old event (to remove): summary_fabric_change
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/r52Jv0tJ1emSvluN5Vgqf/trigger/KJHNn4i-Fkjmkm2KzMkho
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/r52Jv0tJ1emSvluN5Vgqf}
 */
export function cmEditClicked(properties: CmEditClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "r52Jv0tJ1emSvluN5Vgqf", "338fa6235ed4d82c5e6ebfbb0c8219f53b17b84d8bdda13a8b7790e303ed645a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_edit_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("r52Jv0tJ1emSvluN5Vgqf", "cm_edit_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_edit_clicked", eventProperties, "r52Jv0tJ1emSvluN5Vgqf", "338fa6235ed4d82c5e6ebfbb0c8219f53b17b84d8bdda13a8b7790e303ed645a");
    }
    // destination Segment
    Segment.logEvent("cm_edit_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmEditCanceledProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemValue: string;
  cmItemType: CmItemTypeValueType;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_edit_canceled: User cancels the initiated change to customization (e.g. cancel changing style, monogram or fabric)
 * Properties:
 * "configurator_type": "jacket|trousers|suit",
 *  "configurator_section": "jacket_options|summary",
 *  "cm_item_type": "fabric|product|option",
 *  "current_base_style": "havana|slim_leg_single_pleat|, - can be null
 *  "cm_item_value": "monogram_inside-jacket|havana|black_black-wool-stretch",
 *  "page_type": "custommade"
 * 
 * When to trigger this event:
 * 1. Firing when the pop up 'change style' is cancelled.

Properties:

"configurator_type": jacket",
 "configurator_section": "jacket_options",
 "cm_item_type": "base_style",
 "current_base_style": "business"
 "cm_item_value": "business",
 "page_type": "custommade"

-old property cm_option, new property cm_item_value: {{selected option}} example: business|casual|classic-double-breasted

Old event (to delete): style_option_change_cancel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/oQJ5FJOn8rXiXg5xHrsZn/trigger/qiXBhP6BArbmGswha1DvU
 * 2. Firing when the fabric change is being cancelled in the pop up.
Properties:
"configurator_type": "suit",
 "configurator_section": "summary",
 "cm_item_type": "fabric",
 "cm_item_value": "black_black-wool-stretch",
 "page_type": "custommade"
"current_base_style": null


Old event (to delete): summary_fabric_change_cancel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/oQJ5FJOn8rXiXg5xHrsZn/trigger/2u9d5T4NSQCR0UJnM4lEF
 * 3. When monogram change is canceled (user goes back from Edit flow)

Properties:
"configurator_type": "jacket|suit",
 "configurator_section": "jacket_options",
 "cm_item_type": "option",
 "current_base_style": "havana"
 "cm_item_value": "monogram_inside-jacket",
 "page_type": "custommade"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/oQJ5FJOn8rXiXg5xHrsZn/trigger/Z-3vCxeIelIqKLuqtKJ_s
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/oQJ5FJOn8rXiXg5xHrsZn}
 */
export function cmEditCanceled(properties: CmEditCanceledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oQJ5FJOn8rXiXg5xHrsZn", "20930e0e0b0e97cce4a2759ba641e85b89ca9a5ad216dc13be05d1e5a9c5932b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_edit_canceled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oQJ5FJOn8rXiXg5xHrsZn", "cm_edit_canceled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_edit_canceled", eventProperties, "oQJ5FJOn8rXiXg5xHrsZn", "20930e0e0b0e97cce4a2759ba641e85b89ca9a5ad216dc13be05d1e5a9c5932b");
    }
    // destination Segment
    Segment.logEvent("cm_edit_canceled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmEditConfirmedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmItemType: CmItemTypeValueType;
  cmItemValue: string | null | undefined;
  currentBaseStyle: string | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_edit_confirmed: When the user confirms the change of to customization (e.g. cancel changing style, monogram or fabric)
 * Properties:
 * "configurator_type": "jacket|trousers|suit",
 *  "configurator_section": "jacket_options|summary",
 *  "cm_item_type": "fabric|product|option",
 *  "current_base_style": "havana|slim_leg_single_pleat|, - can be null
 *  "cm_item_value": "monogram_inside-jacket|havana|black_black-wool-stretch",
 *  "page_type": "custommade"
 * 
 * When to trigger this event:
 * 1. Firing when the pop up 'change style' is clicked.
Properties:
"configurator_type": "suit",
"configurator_section": "jacket_base_style",
 "current_base_style": "jacket_business"
"cm_item_type": "base_style",
"cm_item_value": "business",
"page_type": "custommade"

- cm_option: {{selected option}} example: business|casual|classic-double-breasted



Old event (to delete): style_option_change_confirm
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MgEkXhwGPqn87HsHwceck/trigger/nETJk0cNWojaTbPEsgD8H
 * 2. Firing when the fabric change is being confirmed in the pop up.
cm_item_type: "fabric"

Properties:
"configurator_type": "suit",
"configurator_section": "summary",
"current_base_style": ""- empty
"cm_item_type": "fabric",
"cm_item_value": "black_black-wool-stretch",
"page_type": "custommade"

Old event (to delete): summary_fabric_change_confirm
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MgEkXhwGPqn87HsHwceck/trigger/r01_4JcW1gEqDoKdsIXSO
 * 3. When the user is finishing the monogram edit flow and clicks 'Apply" button



Properties:
"configurator_type": "suit",
 "configurator_section": "jaclket_options",
 "current_base_style": "jacket_havana"
 "cm_item_type": "option",
 "cm_item_value": "monogram_inside-jacket",
 "page_type": "custommade"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MgEkXhwGPqn87HsHwceck/trigger/RtebTRUL_HL2nAmjYPQGI
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/MgEkXhwGPqn87HsHwceck}
 */
export function cmEditConfirmed(properties: CmEditConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MgEkXhwGPqn87HsHwceck", "4f253a5f8a117b6636af79c6a33794c8895557a3c670c8933da7fc9b3bd60b8d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_edit_confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MgEkXhwGPqn87HsHwceck", "cm_edit_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_edit_confirmed", eventProperties, "MgEkXhwGPqn87HsHwceck", "4f253a5f8a117b6636af79c6a33794c8895557a3c670c8933da7fc9b3bd60b8d");
    }
    // destination Segment
    Segment.logEvent("cm_edit_confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmSelectionConfirmedProperties {
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  currentBaseStyle: string | null | undefined;
  cmItemValue: string | null | undefined;
  cmItemType: CmItemTypeValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_selection_confirmed: When option or style is confirmed by user by clicking on confirmation button or leaving the section (soft confirmation) - e.g. base style, option.
 * Properties: 
 * "configurator_type": "suit |trousers",
 *  "configurator_section": "fabric|base_style|options",
 *  "cm_item_type": "fabric|base_style|basic_option|basic_option_advanced",
 *  "current_base_style": "havana|slim_leg_single_pleat|, - can be empty
 *  "cm_item_value": "slim_leg_single_pleat|havana|black_black-wool-stretch|lining_full-lined|",
 *  "page_type": "custommade"
 * 
 * When to trigger this event:
 * 1. When a style is confirmed by clicking on "Confirm" button.
"cm_item_type": "style"

Properties:
"configurator_type": "suit",
"configurator_section": "trousers_base_style",
"current_base_style": "casual",
"cm_item_type":"style"
 "cm_item_value": "casual",
"page_type": "custommade"

Old event (to remove): style_option_confirm
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/446LshciZKRodUlR3y7D3/trigger/yTDyAXOfIVYoDLIIBl6_m
 * 2. When confirming an option by going back from an option section (soft confirmation)
  "cm_item_type": "basic_option"

Properties:
"configurator_type": "suit"
"configurator_section": basic_options",
"current_base_style": "jacket_havana",
"cm_item_type":"basic_option"
 "cm_item_value: "closure_2-button",
"page_type": "custommade"

Old event (to remove): basic_option_confirm
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/446LshciZKRodUlR3y7D3/trigger/81eBz71F4bXLUy806GH_O
 * 
 * @param properties the properties associated with this event
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.currentBaseStyle: Currently selected style option. E.g. 'havana', 'milano' for jacket, 'slim_leg_flat_front' for trousers etc.
 * not sent for sections that do not have style options (e.g. fabric, summary) 
 * and there is no garment yet selected (cm_item_type is 'fabric' or 'product' - e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * @param properties.cmItemValue: Describes which option was selected, and which outcome was chosen. Description is added in the event.
 * Depending on cm_item_type, can be:
 * fabric - e.g. 'navy herringbone wool silk linen'
 * product - e.g. 'jacket|trousers|shirt|tuxedo_jacket|extra_trousers|' etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'closure'
 * option - option value, e.g. '2 button'. For this cm_item_type -> cm_item_value: {{optionGroup}}_{{option}}_{{optionValue}} example: 'button_sleeve_4-kissing-buttons'
 * option_group_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * Monogram is considered an option, e.g: 
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.cmItemType: Specifies with what type of option the action was made. Can be: 
 * fabric - fabric 
 * product - selected garment, e.g. jacket|trousers|shirt|tuxedo_jacket|extra_trousers| etc.
 * base_style - style of garment, e.g. 'havana'
 * option_group - option (section in UI) selected, e.g. 'Closure'
 * option - option value, e.g. '2 button'
 * option_advanced - advanced option , e.g. 'canvas_ full canvas'
 * option_section_advanced - advanced option (section in UI) , e.g. 'shoulder'
 * filter - specific filter selection, e.g. 'color_black'
 * Monogram is considered an option.
 * e.g. 
 *  'cm_item_type': 'option',
 *  'cm_item_value': 'monogram_inside-jacket',
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/446LshciZKRodUlR3y7D3}
 */
export function cmSelectionConfirmed(properties: CmSelectionConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  properties.currentBaseStyle !== undefined && properties.currentBaseStyle !== null ?
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: properties.currentBaseStyle}) :
    eventPropertiesArray.push({id: "PrlUfGJTPZa61QAZarKpw", name: "current_base_style", value: null});
  properties.cmItemValue !== undefined && properties.cmItemValue !== null ?
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: properties.cmItemValue}) :
    eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_item_value", value: null});
  eventPropertiesArray.push({id: "RV0QGdhYn9bSyMGkWkuEX", name: "cm_item_type", value: properties.cmItemType});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "446LshciZKRodUlR3y7D3", "47a1c2b63db27597929a6d41d4b81b04255fc06d154b28e20d441026b2fa9276", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_selection_confirmed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("446LshciZKRodUlR3y7D3", "cm_selection_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_selection_confirmed", eventProperties, "446LshciZKRodUlR3y7D3", "47a1c2b63db27597929a6d41d4b81b04255fc06d154b28e20d441026b2fa9276");
    }
    // destination Segment
    Segment.logEvent("cm_selection_confirmed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CustomMadeOverlayShowedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  overlayStep: OverlayStepValueType;
  autoTriggered: boolean;
  currency: CurrencyValueType | null | undefined;
}
/**
 * custom_made_overlay_showed: This event is fired when the onboarding panel is shown to the user.  
 * overlay_step": "fabric|fit|intro|style|personalize", - currently shown step
 * "configurator_type": "suit|trousers",
 * "configurator_section": "fabric|style|basic_options|summary",
 * "auto_triggered": true|false, //If the specific overlay step is shown automatically of by user clicking <> buttons
 * 
 * When to trigger this event:
 * 1. When onboarding Overlay is shown shown the new users
overlay_step": "fabric|fit|intro|style|personalize", - currently shown step
"configurator_type": "suit -jacket|trousers",
"configurator_section": "fabric|style|basic_options|summary",
 "default": true|false, //If the specific overlay step is shown automatically of by user clicking <> buttons

To delete events: 
overlay_fabric_showed, overlay_fit_showed, 
overlay_intro_showed, overlay_style_showed, overlay_personalise_showed
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/RJgCmYWhkpqYah6-Nf4em/trigger/w1ngr6-un4GTgU3PdPz_A
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.overlayStep: Specifies which step of the overlay is shown to the user
 * overlay_step = fabric|fit|Intro|style|personalize
 * @param properties.autoTriggered: If change triggered automatically  (yes/no).
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/RJgCmYWhkpqYah6-Nf4em}
 */
export function customMadeOverlayShowed(properties: CustomMadeOverlayShowedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  eventPropertiesArray.push({id: "1quiHy5MgQFaaz0ja_zil", name: "overlay_step", value: properties.overlayStep});
  eventPropertiesArray.push({id: "soDVhWZS2uahWKgkd0kMw", name: "auto_triggered", value: properties.autoTriggered});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RJgCmYWhkpqYah6-Nf4em", "da898c2a7851aab2a2cc4ac679c6311b106fe1a54c9224644e16043d037c5e15", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("custom_made_overlay_showed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RJgCmYWhkpqYah6-Nf4em", "custom_made_overlay_showed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("custom_made_overlay_showed", eventProperties, "RJgCmYWhkpqYah6-Nf4em", "da898c2a7851aab2a2cc4ac679c6311b106fe1a54c9224644e16043d037c5e15");
    }
    // destination Segment
    Segment.logEvent("custom_made_overlay_showed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmPreviewToggleClickedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmSelectedView: CmSelectedViewValueType | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_preview_toggle_clicked: When the user is selecting view on Fabric section
 * 
 * When to trigger this event:
 * 1. When the user is selecting view on Fabric section
layer view selected - "cm_view“: "layer-view"
Model view selected - "cm_view“: "model-view"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/jM__si1ERIJl0lqjVcdi2/trigger/u6R_HsS0ramzOU-JT_NgV
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmSelectedView: Value showing in which view the action is made (Applicable for events on Fabric section, null in other cases)
 * “cm_view“: |model_view|product_view|
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/jM__si1ERIJl0lqjVcdi2}
 */
export function cmPreviewToggleClicked(properties: CmPreviewToggleClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.cmSelectedView !== undefined && properties.cmSelectedView !== null ?
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: properties.cmSelectedView}) :
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "jM__si1ERIJl0lqjVcdi2", "924b7eb8c43b6caebc934349344b95248d9821a532c39fa7b5e9852f8a5555ce", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_preview_toggle_clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("jM__si1ERIJl0lqjVcdi2", "cm_preview_toggle_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_preview_toggle_clicked", eventProperties, "jM__si1ERIJl0lqjVcdi2", "924b7eb8c43b6caebc934349344b95248d9821a532c39fa7b5e9852f8a5555ce");
    }
    // destination Segment
    Segment.logEvent("cm_preview_toggle_clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CmModelViewInfoViewedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  cmSelectedView: CmSelectedViewValueType | null | undefined;
  currency: CurrencyValueType | null | undefined;
}
/**
 * cm_model_view_info_viewed: When user is clicking on info icon on Model view and sees Model view disclaimer tooltip
 * selected_view - always "model_view"
 * 
 * When to trigger this event:
 * 1. When user is clicking on info icon on Model view and sees Disclaimer tooltip
Or tooltip is opened automatically for the users seeing it at the first time
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/zZOsol8v1O4zaZuF63kyD/trigger/rOOJhF4ld7SwLIZssDSsR
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.cmSelectedView: Value showing in which view the action is made (Applicable for events on Fabric section, null in other cases)
 * “cm_view“: |model_view|product_view|
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/zZOsol8v1O4zaZuF63kyD}
 */
export function cmModelViewInfoViewed(properties: CmModelViewInfoViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.cmSelectedView !== undefined && properties.cmSelectedView !== null ?
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: properties.cmSelectedView}) :
    eventPropertiesArray.push({id: "0S5Jl7nuEtrJ9bIc4belS", name: "cm_selected_view", value: null});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "zZOsol8v1O4zaZuF63kyD", "5528c79aa55e93dcc2698148ce51671061dfffd6fe016efe8fcfb74161c5d342", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("cm_model_view_info_viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("zZOsol8v1O4zaZuF63kyD", "cm_model_view_info_viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cm_model_view_info_viewed", eventProperties, "zZOsol8v1O4zaZuF63kyD", "5528c79aa55e93dcc2698148ce51671061dfffd6fe016efe8fcfb74161c5d342");
    }
    // destination Segment
    Segment.logEvent("cm_model_view_info_viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricFilterClearedAllProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * fabric_filter_cleared_all: When the user clicks on "Clear all" in Fabric filter panel
 * 
 * When to trigger this event:
 * 1. When the user clicks on "Clear all"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KLWKO8gN3ZvtN1tO3-m18/trigger/PU-AyHeLxEZ2vQhlacYXC
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/KLWKO8gN3ZvtN1tO3-m18}
 */
export function fabricFilterClearedAll(properties: FabricFilterClearedAllProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KLWKO8gN3ZvtN1tO3-m18", "0e3b93cbfc81c549b0b3adf3ae9e8d239e38a1619e90c9d1a9fccc0d28d687b3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_filter_cleared_all", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KLWKO8gN3ZvtN1tO3-m18", "fabric_filter_cleared_all", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_filter_cleared_all", eventProperties, "KLWKO8gN3ZvtN1tO3-m18", "0e3b93cbfc81c549b0b3adf3ae9e8d239e38a1619e90c9d1a9fccc0d28d687b3");
    }
    // destination Segment
    Segment.logEvent("fabric_filter_cleared_all", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricFilterClosedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * fabric_filter_closed: When user clicks to close “X”/“Results” buttons to close filter panel on Fabric section
 * 
 * When to trigger this event:
 * 1. When user clicks to close “X”/“Results” buttons to close filter panel.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/PZEfGttzH6476E35DB-aU/trigger/5HQPnAAJ1VFcWCvH_CPh2
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/PZEfGttzH6476E35DB-aU}
 */
export function fabricFilterClosed(properties: FabricFilterClosedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PZEfGttzH6476E35DB-aU", "4cc3f177c70586d5e10031edfa67a6c7bd47c30adc8fcde763dad517bdea619f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_filter_closed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PZEfGttzH6476E35DB-aU", "fabric_filter_closed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_filter_closed", eventProperties, "PZEfGttzH6476E35DB-aU", "4cc3f177c70586d5e10031edfa67a6c7bd47c30adc8fcde763dad517bdea619f");
    }
    // destination Segment
    Segment.logEvent("fabric_filter_closed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FabricFilterOpenedProperties {
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType | null | undefined;
  eventLocation: string;
  configuratorType: ConfiguratorTypeValueType;
  configuratorSection: ConfiguratorSectionValueType;
  cmUserFlow: CmUserFlowValueType;
  currency: CurrencyValueType | null | undefined;
}
/**
 * fabric_filter_opened: Trigger when Filter Button is clicked on Fabric section 
 * 
 * When to trigger this event:
 * 1. Trigger when Filter Button is clicked on Fabric section 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HmEVfOi5CaNy4x9gURICm/trigger/R2ko7mTS9M2BiS_Z2KKs2
 * 
 * @param properties the properties associated with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: Location of the element that triggered the event (panel, slider, promotion block, etc.). Known values:
 * - Wishlist panel: wishlist_panel
 * - PDP customize button: empty
 * - PDP size picker: size-picker
 * - Size passport size picker tab: standard-size-passport_panel
 * - Size passport saved passport tab: saved-size-passport_panel
 * - Size passport: size-passport_panel
 * - Shop the look panel: shop_the_look_hero, products_mwtw_{{number}}
 * - Add to bag panel: minicart_panel
 * - OOS panel: oos
 * - Out-of-stock panel: out_of_stock_panel
 * - Mix and match panel: mixandmatch
 * - Perfect White shirt finder: pwsf_panel
 * - PDP size guide button: pdp
 * - Lookbuilder: lookbuilder_summary
 * - Similar products: similar_products_panel
 * - Order list page: order_list
 * - Order details page: order_details
 * - book_store_appointment_clicked (Shopify source): store_card, store_list, services_cta, services_item, store_faq, style_expert, expert_panel, or cms_<module> (CMS component name, e.g. cms_hero)
 * @param properties.configuratorType: The configurator being used. E.g. 'suit', 'jacket', 'tuxedo_trousers', 'tuxedo_jacket', 'shirt'
 * For summary-specific events for Suit/Tuxedo configurators that involve interaction with a specific product, the property should contain 'suit' and a product it's related to. 
 * E.g. 'suit_jacket|suit_trouser|suit_extra_trouser|tuxedo_extra_trouser'
 * @param properties.configuratorSection: Current section within configurator. E.g. 'fabric|jacket_base_style|trousers_base_style|…|jacket_options|shirt_options|…|summary'
 * @param properties.cmUserFlow: Specifies current user flow, for example, customize flow - if the user opened configurator from PDP by clicking on 'Customize' button
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/events/HmEVfOi5CaNy4x9gURICm}
 */
export function fabricFilterOpened(properties: FabricFilterOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.eventLabel !== undefined && properties.eventLabel !== null ?
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
    eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
  properties.eventCategory !== undefined && properties.eventCategory !== null ?
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory}) :
    eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: null});
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
  eventPropertiesArray.push({id: "-do32Im19M_ts-0lIL4Nf", name: "configurator_type", value: properties.configuratorType});
  eventPropertiesArray.push({id: "3gQ3flregEVC3IxR25KxY", name: "configurator_section", value: properties.configuratorSection});
  eventPropertiesArray.push({id: "5MI0-H0jd7ri2jBrK-gBF", name: "cm_user_flow", value: properties.cmUserFlow});
  properties.currency !== undefined && properties.currency !== null ?
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency}) :
    eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: null});
  eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
  eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
  eventPropertiesArray.push({id: "242drTJv3Rt-GJq3CwYuz", name: "affiliateMarker", value: sysAffiliateMarker});
  eventPropertiesArray.push({id: "P-qA2e25zx5I-aiwOgIPX", name: "awc", value: sysAwc});
  eventPropertiesArray.push({id: "ieP6KbWa3Ew9PwYElP3Td", name: "country", value: sysCountry});
  eventPropertiesArray.push({id: "Vz6ocKyzjPFbKKTZBY6XI", name: "language", value: sysLanguage});
  eventPropertiesArray.push({id: "McbR9Yxeb6Too56gO8Kp4", name: "location_id", value: sysLocationId});
  eventPropertiesArray.push({id: "EUOwclkK9Qy6-tfoD3T2o", name: "user_id", value: sysUserId});
  eventPropertiesArray.push({id: "NIYSMNV99w6jQoYUs8E2H", name: "logged_in", value: sysLoggedIn});
  eventPropertiesArray.push({id: "W-qdxZDGqzr6_fYbK01O7", name: "page_type", value: sysPageType});
  eventPropertiesArray.push({id: "suYf_bMdhht1_OUwkJWDz", name: "ga_client_id", value: sysGaClientId});
  eventPropertiesArray.push({id: "gSa7kcAmm8uGHaQ-z23BR", name: "ga_session_id", value: sysGaSessionId});
  eventPropertiesArray.push({id: "qcjUwMNAoYWEFXWHS1oZI", name: "ga_session_number", value: sysGaSessionNumber});
  eventPropertiesArray.push({id: "ljvMnb5ZON5zXb6WlytE9", name: "fb_fbp", value: sysFbFbp});
  eventPropertiesArray.push({id: "DHDAacGksFllKhgFMeeHk", name: "fb_fbc", value: sysFbFbc});
  eventPropertiesArray.push({id: "RYOU9dFCD3d4ARxP6KNM4", name: "ga_aw_clid", value: sysGaAwClid});
  eventPropertiesArray.push({id: "2Q6KI21zMs7KhIXlM0IIh", name: "ttclid", value: sysTtclid});
  eventPropertiesArray.push({id: "cMmRVdYNVmJs_dfLc0ypT", name: "msclkid", value: sysMsclkid});
  eventPropertiesArray.push({id: "FGkH8Wm7zhOCpuQUoqTKN", name: "twclid", value: sysTwclid});
  eventPropertiesArray.push({id: "Bg0wHTduZfO8vt4TMTiuw", name: "rdt_cid", value: sysRdtCid});
  eventPropertiesArray.push({id: "VCj1NL657Q-bfb2hBhJt4", name: "epik", value: sysEpik});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HmEVfOi5CaNy4x9gURICm", "626c5db5b01d187a6639ac625c3da23f702b3fd0d0b5c59d3583bc8062116192", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("fabric_filter_opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HmEVfOi5CaNy4x9gURICm", "fabric_filter_opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_filter_opened", eventProperties, "HmEVfOi5CaNy4x9gURICm", "626c5db5b01d187a6639ac625c3da23f702b3fd0d0b5c59d3583bc8062116192");
    }
    // destination Segment
    Segment.logEvent("fabric_filter_opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  ConfiguratorType,
  CmSelectedView,
  OverlayStep,
  CmLiteFit,
  ConfiguratorSection,
  CmUserFlow,
  LoggedIn,
  CmItemType,
  EventCategory,
  Language,
  PageType,
  CmLiteVariantFit,
  Affiliation,
  Brand,
  SaveMethod,
  SelectedCategory,
  Country,
  Currency,
  Creative,
  ApplicationId,
  PreviousCategory,
  productViewed,
  productViewedCm,
  productAdded,
  productAddedCm,
  pageLoaded,
  pageLoadedCm,
  promotionViewed,
  promotionViewedStorePages,
  promotionClicked,
  promotionClickedStorePages,
  styleOptionSelect,
  showAdvancedOptions,
  showAdvancedOptionsSp,
  advancedSectionSelect,
  advancedOptionConfirm,
  summarySeeAllDetails,
  summaryFinishInStore,
  summarySaveAndShare,
  summaryEdit,
  fabricFilterSelected,
  fabricInformation,
  custommadeFinished,
  customMadeDesigningStarted,
  customMadeOverlayExited,
  sizePassportLoginClicked,
  searchClicked,
  searchClickedCustomMade,
  customMadeCategoryChanged,
  editSizePassportClicked,
  sizePassportSizeGuideClicked,
  customMadeDesignShared,
  bookStoreAppointmentClicked,
  cmCustomizationAdded,
  cmCustomizationDeleteInitiated,
  cmCustomizationDeleteConfirmed,
  cmCustomizationDeleteCancelled,
  cmSelectionClicked,
  cmEditClicked,
  cmEditCanceled,
  cmEditConfirmed,
  cmSelectionConfirmed,
  customMadeOverlayShowed,
  cmPreviewToggleClicked,
  cmModelViewInfoViewed,
  fabricFilterClearedAll,
  fabricFilterClosed,
  fabricFilterOpened,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["productViewed","productViewedCm","productAdded","productAddedCm","pageLoaded","pageLoadedCm","promotionViewed","promotionViewedStorePages","promotionClicked","promotionClickedStorePages","styleOptionSelect","showAdvancedOptions","showAdvancedOptionsSp","advancedSectionSelect","advancedOptionConfirm","summarySeeAllDetails","summaryFinishInStore","summarySaveAndShare","summaryEdit","fabricFilterSelected","fabricInformation","custommadeFinished","customMadeDesigningStarted","customMadeOverlayExited","sizePassportLoginClicked","searchClicked","searchClickedCustomMade","customMadeCategoryChanged","editSizePassportClicked","sizePassportSizeGuideClicked","customMadeDesignShared","bookStoreAppointmentClicked","cmCustomizationAdded","cmCustomizationDeleteInitiated","cmCustomizationDeleteConfirmed","cmCustomizationDeleteCancelled","cmSelectionClicked","cmEditClicked","cmEditCanceled","cmEditConfirmed","cmSelectionConfirmed","customMadeOverlayShowed","cmPreviewToggleClicked","cmModelViewInfoViewed","fabricFilterClearedAll","fabricFilterClosed","fabricFilterOpened"]
